<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleDeleteConfirmationPopup"
					/>
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="showNewModelForm"
					/>
					<div v-if="showDeleteConfirmationPopup">
						<ExclusionAlert
							:farm-name="nomeFazenda"
							:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
							@cancel="toggleDeleteConfirmationPopup"
							@confirm="deleteModels"
						>
							<template #item="{ item }">
								<li class="exclusion-alert-item">
									{{ $t('code') }} : {{ item.orsv_cd_codigo }} - {{ $t('descricao') }} :
									{{ item.orsv_ds_descricao }}
								</li>
							</template>
						</ExclusionAlert>
					</div>
				</div>
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="searchQuery"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div class="container__crudactions__filtercollums__collumns">
					<DropdownCheckbox v-model="tableHeaders" />
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						style="border-radius: 5px !important; width: 65px"
						:loading="exportando"
						@click="downloadCSVOrdemDeServico()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotalPagination.items"
			:table-configuration="tableConfiguration"
			:value-selected="valueSelected.menu"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions(dataObject)"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<GridPagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="modelsToBeShowedAndTotalPagination.total"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
				@refreshTable="refreshTabela"
			/>
		</div>

		<div
			v-show="!showForm"
			v-if="mostrarMapaPlantio == true"
			class="BackArrow"
			style="display: flex; gap: 1rem; align-items: center"
		>
			<Button
				style="padding-right: 17px !important"
				icon="fas fa-solid fa-arrow-left"
				outlined
				@click="changeFormAndCloseAllActionsCRUD"
			/>
			<p
				v-if="isEdit && model.tpsv_cd_codigo === '007'"
				class="go__to__plan__text"
				style="margin: 0; cursor: pointer"
				@click="irParaOperacoes"
			>
				{{ $t('viewOperation') }} ➝
			</p>
		</div>

		<CrudForm
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActionsCRUD"
			:backdrop="!mostrarMapaPlantio"
			:title-form="tituloDoFormulario"
		>
			<template #actions>
				<Steps v-if="!mostrarInventarioDePilha">
					<Step
						:title="`${isEdit ? $t('edition') : $t('registry')}`"
						:description="`${isEdit ? $t('changeTheData') : $t('mainData')}`"
						:completed="isEdit || mostrarMapaPlantio || mostrarOperacao"
						:active="!mostrarMapaPlantio && !mostrarOperacao"
					/>
					<Step
						:title="$t('planning')"
						:description="$t('planningTime')"
						:completed="!isGeoJsonPlantioEmpty && mostrarOperacao"
						:disabled="!mostrarMapaPlantio && !mostrarOperacao"
						:active="mostrarMapaPlantio && !mostrarOperacao"
					/>
					<Step
						:title="$t('operation')"
						:description="$t('operationSettings')"
						:completed="false"
						:disabled="!mostrarOperacao"
						:active="mostrarOperacao"
					/>
				</Steps>
			</template>

			<template #form>
				<div
					v-if="!mostrarMapaPlantio && !mostrarInventarioDePilha"
					class="form__template__section p-4 gap-2"
				>
					<div
						style="
							padding: 0.5rem;
							background: rgba(93, 194, 219, 0.2);
							border-radius: 5px;
							color: var(--color-navy-blu);
							display: flex;
							justify-content: space-between;
							align-items: center;
							cursor: pointer;
							font-weight: 700;
							margin: 1rem 0;
						"
						@click="loteSingleTrees = !loteSingleTrees"
					>
						<span v-if="!loteSingleTrees">{{ $t('criarLoteSingleTrees') }}</span>
						<span v-else>{{ $t('retornarAoCadastroTradicional') }}</span>
						<i class="fas fa-angle-right" />
					</div>
					<div
						v-if="loteSingleTrees"
						style="display: flex; flex-direction: column; gap: 1rem"
					>
						<DropdownCheckboxFk
							:label="$t('forestStratification')"
							:dropdown-options="
								estratosFlorestais.map((m) => Object.assign(m, { Nome: m.esfl_ds_descricao }))
							"
							:ignore-properties="[
								'estratoPossuiMedicao',
								'id',
								'esfl_cd_codigo',
								'esfl_is_traditional',
								'fk_fzda_fazenda',
								'fzda_nm_nome',
								'estratoFoiPlanejado',
								'Bloqueado',
							]"
							:value="estratosSelecionados"
						/>

						<DropdownCheckboxFk
							:empty-label="$t('noneCollector')"
							:label="$t('collectors')"
							:dropdown-options="executores"
							:ignore-properties="['id', $t('blocked')]"
							:value="executoresSelecionadosColeta"
						/>

						<Button
							:disabled="!estratosSelecionados.length"
							:label="`Criar ${estratosSelecionados.length} coletas Single Trees`"
							@click="criarLoteSingleTrees"
						/>
					</div>
					<div v-else>
						<div class="flex flex-col gap-4">
							<InputText
								v-model="model.orsv_ds_descricao"
								:label="$t('description') + '*'"
							/>

							<DropdownFk
								v-model="model.fk_esfl_estrato_florestal"
								:label="$t('forestStratification') + '*'"
								:hidden-properties="[
									'esfl_cd_codigo',
									'esfl_ds_descricao',
									'esfl_is_traditional',
									'fzda_nm_nome',
									'estratoFoiPlanejado',
								]"
								:dropdown-options="estratosFormatados"
							/>
							<Dropdown
								v-model="model.fk_tpsv_tipo_servico"
								:label="$t('serviceTypes') + '*'"
								:disabled="isDropdownTiposServicoDisable"
								:options="tiposDeServicoComputados"
							/>
							<DatePicker
								v-model="model.orsv_dt_data_inicial"
								:label="$t('startDate')"
								:max-date="model.orsv_dt_prazo_final"
							/>
							<DatePicker
								v-model="model.orsv_dt_prazo_final"
								:label="$t('deadline')"
								:min-date="model.orsv_dt_data_inicial"
							/>

							<DropdownCheckboxFk
								:empty-label="$t('noneCollector')"
								:label="$t('collectors')"
								:dropdown-options="executores"
								:ignore-properties="['id', 'Bloqueado']"
								:value="executoresSelecionados"
							/>
							<p v-if="temUsuarioBloqueadoSelecionado">
								{{ $t('helpBlockedCollector') }}
							</p>

							<Dropdown
								v-show="
									!isSingleTrees &&
									!isInventarioDePilha &&
									!isColetaDeCubagem &&
									!isColetaSingleTrees
								"
								v-model="model.orsv_tx_forma_parcela"
								:label="`${$t('plotFormat')} *`"
								:options="[
									{ value: 'Circular', label: $t('circular') },
									{ value: 'Quadrada', label: $t('square') },
									{ value: 'Retangular', label: $t('rectangular') },
								]"
							/>
							<InputText
								v-show="
									!isSingleTrees &&
									!isInventarioDePilha &&
									!isColetaDeCubagem &&
									!isColetaSingleTrees
								"
								v-model="model.orsv_md_medida_parcela"
								:label="`${$t('plotSize')} (m²)`"
								@input="limitInput"
							/>
							<InputText
								v-show="!isColetaDeCubagem"
								v-model.number="model.orsv_md_geofence"
								v-mask="'####'"
								:label="`${$t('geofence')} (m)`"
							/>

							<div
								v-if="showDataConsistencySwitcher"
								class="flex flex-col gap-4"
							>
								<ToggleSwitch
									id="verificar-consistencia"
									v-model="model.verificarConsistencia"
									:disabled="model.orsv_is_blocked"
									label="Consistência com dados históricos"
								/>

								<div v-if="model.verificarConsistencia">
									<DropdownFk
										v-if="isSelectedStratumContinuous"
										v-model="model.inventarioReferencia"
										:disabled="model.orsv_is_blocked"
										:dropdown-options="dropdownConsistencia"
										label="Inventário de referência*"
									/>
									<div v-else>
										<SFMessage
											size="sm"
											title="Estrato tipo Temporário (Spot)"
											description="Para esse tipo de estrato, a Treevia irá utilizar as últimas medições para cada talhão, se baseando no Inventário Florestal selecionado como favorito."
											type="info"
										/>
									</div>
								</div>
								<div
									style="display: flex"
									class="gap-2 items-center"
								>
									<SFCheckbox
										v-model="model.prePreencherEstruturaInventarioAnterior"
										:disabled="model.orsv_is_blocked || !model.verificarConsistencia"
										label="Pré-preencher a estrutura do inventário anterior"
									/>
									<div class="w-fit block">
										<Tooltip :options="{ placement: 'top' }">
											<template #trigger>
												<Icon
													icon="octicon:question-16"
													class="text-sm text-gray-medium"
												/>
											</template>
											<div class="flex flex-col gap-2 max-w-xs p-2">
												<p class="text-s-bold">Estrutura inventário anterior</p>
												<p class="text-s">
													Ao habilitar o checkbox, além de realizar as validações de dados do
													inventário anterior, o mobile irá pré-preencher toda a estrutura de
													linha-árvore-fuste das parcelas, permitindo a auditoria e também a
													orientação do coletor. Quando desabilitado, a parcela virá em branco porém
													a validação dos dados durante a coleta se mantém.
												</p>
											</div>
										</Tooltip>
									</div>
								</div>
							</div>

							<div
								v-show="model.tpsv_cd_codigo != '008' && model.tpsv_cd_codigo != '010'"
								style="display: flex; justify-content: space-between; padding: 0.5rem 0"
							>
								<div />
								<p
									v-if="isEdit && model.tpsv_cd_codigo !== '018'"
									class="go__to__plan__text"
									@click="verPlanejamento"
								>
									<Loading v-if="isGeoJsonPlantioEmpty && model.tpsv_cd_codigo != '005'" />
									{{
										model.tpsv_cd_codigo === '005'
											? 'Visualizar planejamento de cubagem ➝'
											: `${$t('goPlan')} ➝`
									}}
								</p>
							</div>

							<div class="container__crud__crudform__buttons">
								<Button
									:label="$t('cancel')"
									color="trv-default"
									semantic-class="mini"
									outlined
									@click="changeFormAndCloseAllActions"
								/>

								<Button
									:label="!isInventarioDePilha ? $t('save') : $t('next')"
									color="trv-default"
									semantic-class="mini"
									:disabled="
										disableSaveButton || !camposObrigatoriosPreenchidos || buscandoOrdemDePilha
									"
									:loading="buscandoOrdemDePilha"
									@click="confirmClick()"
								/>
							</div>
						</div>
					</div>
				</div>
				<div v-else-if="mostrarInventarioDePilha">
					<PlanejamentoOrdemDeServicoPilha
						ref="planejamentoOrdemServico"
						:estrato-florestal-id="model.fk_esfl_estrato_florestal"
						:ordem-de-servico-id="model.id"
						:estrato-florestal="descricaoEstratoFlorestalFormulario"
						:descricao-ordem-de-servico="model.orsv_ds_descricao"
						:data-inicial="dateDataDeInicioOs"
						:prazo-de-execucao="dateDataDePrazoExecucao"
						:executores="executoresSelecionados"
						:geofence="model.orsv_md_geofence"
						:dados-de-pilha-para-edicao="ordemDeServicoDePilha"
						@salvouPlanejamentoDePilha="salvouPlanejamentoDePilha"
						@editouPlanejamentoDePilha="editouPlanejamentoDePilha"
						@fecharModal="fecharModal"
					/>
				</div>
				<div
					v-else
					style="display: flex; flex-direction: column; gap: 0.5rem"
				>
					<div
						style="
							margin: 1rem 0;
							border-radius: 5px;
							display: flex;
							align-items: center;
							background-color: var(--color-background);
							padding: 1rem;
							flex-direction: row;
							justify-content: space-between;
						"
					>
						<div style="display: flex; flex-direction: row; gap: 1rem">
							<i
								style="vertical-align: sub; font-size: 1.6rem"
								class="fas fa-tree"
							/>
							<div>
								<p class="info__title__service__name">
									{{ model.orsv_ds_descricao }}
								</p>
								<p
									:title="model.esfl_ds_descricao"
									style="height: fit-content; padding: 0; font-size: 0.7rem; margin: 0"
								>
									{{
										model.esfl_ds_descricao ||
										estratosFlorestais.find((f) => f.id === model.fk_esfl_estrato_florestal)
											.esfl_ds_descricao
									}}
								</p>
							</div>
						</div>
						<KebabMenu
							v-model="intentionOrdemServico"
							style="right: 2rem"
							:options="kebabOptionsOrdemServico"
						/>
					</div>
					<div class="flex w-full justify-evenly">
						<Tab
							:text="$t('generatePlots')"
							:active="generationType === 1"
							@click="generationType = 1"
						/>
						<Tab
							v-show="isEdit == true || isCreate == true"
							:text="$t('uploadPlots')"
							:active="generationType === 2"
							@click="generationType = 2"
						/>
					</div>
					<div
						v-show="generationType === 1"
						class="flex gap-4 flex-col"
					>
						<p style="margin: 0">
							<b style="font-size: 14px">{{ $t('generate') }} {{ marcador }}</b>
							<br />
							{{ $t('helpGenerateMarker') }} {{ marcador }}
						</p>

						<div
							v-if="codigoTipoServico !== '009'"
							style="display: flex; flex-direction: column; gap: 0.5rem"
						>
							<Switcher
								v-show="disponibilizarSwitcherDeCoeficienteDeVariacao"
								v-model="model.orsv_is_cv"
								style="font-weight: 800"
								:label="$t('calculateByCV')"
							/>
							<div
								v-if="model.orsv_is_cv"
								style="display: flex; flex-direction: column; gap: 0.5rem"
							>
								<InputText
									v-model.number="coeficienteVariacao.amostrasReferencia"
									:label="`${$t('numberOf')} ${marcador} ${$t('reference')}`"
									type="number"
								/>
								<InputText
									v-model.number="coeficienteVariacao.coeficiente"
									:label="$t('coefficientVariation')"
									type="number"
								/>
								<InputText
									v-model.number="coeficienteVariacao.targetErro"
									:label="$t('errorTarget')"
									type="number"
								/>
								<hr style="margin: 15px 0" />
							</div>
							<InputText
								v-model.number="model.orsv_nr_intensidade_amostral"
								:label="`${$t('acre')} / ${marcador}`"
								:disabled="model.orsv_is_cv"
								type="number"
								@keyup="calcularTotalDeAmostra"
							/>
							<InputText
								v-model.number="model.orsv_nr_amostra_total"
								:label="`${$t('totalOf')} ${marcador}`"
								:disabled="model.orsv_is_cv"
								type="number"
								@keyup="calcularIntensidadeAmostral"
							/>
							<InputText
								v-model.number="model.orsv_nr_buffer"
								:label="`${$t('sectionBuffer')} (m)`"
								type="number"
							/>
							<InputText
								v-show="model.tpsv_cd_codigo === '003'"
								v-model.number="bufferParcela"
								:label="`${$t('buffer')} ${marcador} (m)`"
								type="number"
							/>
							<Dropdown
								v-model="model.orsv_tx_metodologia_amostral"
								:label="$t('samplingMethodology')"
								:options="metodologiasAmostrais"
								value="Sistemático"
							/>

							<Switcher
								v-if="isSingleTrees"
								v-model="model.orsv_is_bitterlich"
								style="font-weight: 800; margin-top: 0.5rem"
								:label="$t('runBitterlich')"
							/>

							<div
								v-if="parcelas.length"
								style="justify-content: center; display: flex; margin: 0.5rem 0"
							>
								<Tag
									v-if="model.orsv_nr_amostra_total"
									class-name="default outlined"
									:label="`${parcelas.length}/${model.orsv_nr_amostra_total} ${marcador}s`"
								/>
								<Tag
									v-else
									class-name="default outlined"
									:label="`${parcelas.length} ${marcador}s`"
								/>
							</div>
							<p
								v-if="mensagemDeIntensidadeAmostral"
								v-html="mensagemDeIntensidadeAmostral"
							/>
							<SFMessage
								v-if="plotsWithoutCoords.length"
								size="sm"
								type="warning"
								:title="`${plotsWithoutCoords.length} ${marcador} ${plotsWithoutCoords.length === 1 ? '' : 's'} sem coordenadas`"
								description="Parcelas sem coordendas serão desconsideradas em inventários"
							/>
							<Button
								:label="`${$t('throw')} ${marcador}s`"
								:disabled="
									!(
										model.orsv_nr_intensidade_amostral &&
										model.orsv_nr_amostra_total &&
										model.orsv_tx_metodologia_amostral
									) || instalacaoSingleTreesEJaPossuiAmostraSalva
								"
								@click="lancarMarcadores"
							/>
						</div>
					</div>
					<div v-show="generationType === 2">
						<p style="margin: 0">
							<b style="font-size: 14px"
								>{{ $t('upload').charAt(0).toUpperCase() + $t('upload').slice(1) }}
								{{ marcador }}</b
							>
							<br />
							{{ $t('helpUploadMarker') }} {{ marcador }}
						</p>

						<div
							v-show="isEdit == true || isCreate == true"
							style="padding-left: 0px; padding-right: 0px"
							class="container__importshape__shapefiles__files"
						>
							<ShapeFileUpload
								ref="ref__shapefileupload"
								:fzda-id="model.id"
								:show-fzda="false"
								:show-tlho="false"
								:show-pltio="false"
								:show-prcla="true"
								:mostrar-importar="false"
								:ordem-servico-id="model.id"
								:fk-estrato="model.fk_esfl_estrato_florestal"
								:tipo-o-s="model.tpsv_cd_codigo"
							/>
						</div>
						<Dropdown
							v-show="!isGeoJsonParcelaEmpty"
							v-model="parcelaProperties"
							:options="parcelaProperties"
							:label="`${$t('codeOf')} ${marcador}`"
						/>
					</div>
					<div
						v-if="isEdit && model.tpsv_cd_codigo === '007'"
						style="display: flex; justify-content: flex-end; padding: 0.5rem 0; margin-top: 1rem"
					>
						<p
							class="go__to__plan__text"
							style="margin: 0; cursor: pointer"
							@click="irParaOperacoes"
						>
							{{ $t('viewOperation') }} ➝
						</p>
					</div>
					<div class="flex mt-4 gap-4">
						<Button
							:label="$t('back')"
							outlined
							color="trv-secondary"
							class="w-full"
							semantic-class="mini"
							@click="changeFormAndCloseAllActions"
						/>
						<Button
							:label="isOrdemServicoInstalacao ? 'Avançar' : $t('save')"
							semantic-class="mini"
							class="w-full"
							:loading="salvandoPlanejamento"
							:disabled="instalacaoSingleTreesEJaPossuiAmostraSalva"
							@click="handleSalvarPlanejamento"
						/>
					</div>
					<br />
				</div>
			</template>
		</CrudForm>

		<CrudForm
			:is-visible="isResumo"
			:change-is-visible="changeFormAndCloseAllActionsResumo"
			:backdrop="!mostrarMapaPlantio"
			:title-form="titleForm"
		>
			<template #form>
				<br />
				<div>
					<p style="font-weight: 700; font-size: 1rem">
						{{ $t('serviceOrder') }}
					</p>
					<p style="font-size: 0.9rem">
						{{ model.orsv_ds_descricao }}
					</p>
					<p style="font-weight: 700; font-size: 1rem">
						{{ $t('dueDate') }}
					</p>
					<p style="font-size: 0.9rem">
						{{ model.prazoFinal }}
					</p>
				</div>
			</template>
		</CrudForm>

		<PlanejamentoOrdemServico
			v-if="mostrarMapaPlantio"
			ref="planejamentoOrdemServico"
			:close="closeOrdemServico"
			:parcelas="parcelas"
			:ordem-servico="model"
			:is-ordem-servico-instalacao="isOrdemServicoInstalacao"
			:create-codigo-parcela="createCodigoParcela"
			:find-plantio-geo-by-point="findPlantioGeoByPoint"
			:adiciona-parcela="adicionaParcela"
			:icone-parcela="iconeParcela"
			:is-in-any-plantio="isInAnyPlantio"
			:validar-marcadores="validarMarcadores"
			:validar-intensidade-amostral-por-plantio="validarIntensidadeAmostralPorPlantio"
			:show-info-plantio="togglePlantio"
			:codigo-de-parcela-em-uso-no-banco="codigoDeParcelaEmUsoNoBanco"
			:is-single-trees="isSingleTrees"
			:numero-de-fustes="numeroDeFustes"
			@deleteParcela="handleDelete"
		/>

		<CrudForm
			v-if="mostrarOperacao"
			:is-visible="mostrarOperacao"
			:backdrop="true"
			:change-is-visible="voltarParaPlanejamento"
			:title-form="tituloDoFormulario"
		>
			<template #actions>
				<Steps>
					<Step
						:title="`${isEdit ? $t('edition') : $t('registry')}`"
						:description="`${isEdit ? $t('changeTheData') : $t('mainData')}`"
						:completed="true"
						:active="false"
					/>
					<Step
						:title="$t('planning')"
						:description="$t('planningTime')"
						:completed="true"
						:active="false"
					/>
					<Step
						:title="$t('operation')"
						:description="$t('operationSettings')"
						:completed="false"
						:active="true"
					/>
				</Steps>

				<div
					style="
						margin: 1rem 0;
						border-radius: 5px;
						display: flex;
						align-items: center;
						background-color: var(--color-background);
						padding: 1rem;
						flex-direction: row;
						justify-content: space-between;
					"
				>
					<div style="display: flex; flex-direction: row; gap: 1rem">
						<i
							style="vertical-align: sub; font-size: 1.6rem"
							class="fas fa-tree"
						/>
						<div>
							<p class="info__title__service__name">
								{{ model.orsv_ds_descricao }}
							</p>
							<p
								:title="model.esfl_ds_descricao"
								style="height: fit-content; padding: 0; font-size: 0.7rem; margin: 0"
							>
								{{
									model.esfl_ds_descricao ||
									estratosFlorestais.find((f) => f.id === model.fk_esfl_estrato_florestal)
										?.esfl_ds_descricao
								}}
							</p>
						</div>
					</div>
				</div>
			</template>

			<template #form>
				<div class="form__template__section p-4 gap-4">
                   <h2 style="font-family: Open Sans; font-weight: 700; font-style: bold; font-size: 24px; line-height: 28px; letter-spacing: -1px; margin: 0;">
 					  {{ $t('operationSettings') }}
				   </h2>
					<p style="margin: 0; font-size: 0.9rem; color: #666">
						{{ $t('defineInitialDendrometerSettings') }}
					</p>

					<div
						v-if="!isEdit || !model.orsv_tx_versao_dendrometro"
						style="margin-top: 1rem"
					>
						<RadioButtons
							v-model="model.orsv_tx_versao_dendrometro"
							group-name="versaoDendrometro"
							label="Versão do dendrômetro *"
							:options="[
								{ label: 'DLR 1.0', value: 'DLR 1.0' },
								{ label: 'DLR 1.5', value: 'DLR 1.5' },
							]"
						/>
					</div>

					<div
						v-if="model.orsv_tx_versao_dendrometro === 'DLR 1.0'"
						style="margin-top: 1rem"
					>
						<SFMessage
							size="sm"
							:description="$t('dlr10OperationSettingsDoneByApp')"
							type="info"
						/>
					</div>

					<div
						v-if="model.orsv_tx_versao_dendrometro === 'DLR 1.5'"
						style="display: flex; flex-direction: column; gap: 1rem; margin-top: 1rem"
					>
						<div style="display: flex; gap: 1rem">
							<div style="flex: 1; max-width: 50%; position: relative">
								<DatePicker
									v-model="model.orsv_dt_hora_inicio_medicao"
									:label="$t('measurementStartDateTime') + ' *'"
									@input="handleDataChange"
								/>
								<div
									v-if="camposOperacaoDesabilitados || camposDataHoraDesabilitados"
									style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; cursor: not-allowed; z-index: 10"
									@click.stop
								></div>
							</div>
							<InputText
								v-model="horaInicio"
								placeholder="10:00"
								style="flex: 1; max-width: 50%; margin-top: 1.15rem"
								mask="##:##"
								:disabled="camposOperacaoDesabilitados || camposDataHoraDesabilitados"
								@input="handleHoraChange"
							/>
						</div>

						<Dropdown
							:value="fusoHorario"
							:label="$t('timezone') + ' *'"
							:options="fusosHorarios"
							:disabled="camposOperacaoDesabilitados || camposDataHoraDesabilitados"
							@input="handleFusoHorarioChange"
						/>

						<Dropdown
							:key="'frequencia-' + dropdownKey"
							:value="model.orsv_tx_frequencia_coleta"
							:label="$t('collectionFrequency') + ' *'"
							:options="frequenciaColetaOptions"
							:disabled="camposOperacaoDesabilitados"
							@input="handleFrequenciaChange"
						/>

						<Dropdown
							:key="'periodo-' + dropdownKey"
							:value="model.orsv_tx_periodo_disponivel"
							:label="$t('availablePeriodForCollection') + ' *'"
							:options="periodoDisponivelOptions"
							:disabled="camposOperacaoDesabilitados"
							@input="handlePeriodoChange"
						/>
					</div>

					<div
						style="
							display: flex;
							gap: 1rem;
							margin-top: 2rem;
							justify-content: flex-end;
						"
					>
						<Button
							:label="$t('cancel')"
							color="trv-default"
							outlined
							@click="voltarParaPlanejamento"
						/>
						<Button
							:label="model.orsv_tx_versao_dendrometro === 'DLR 1.5' ? $t('advance') : $t('finalize')"
							:disabled="!model.orsv_tx_versao_dendrometro || (model.orsv_tx_versao_dendrometro === 'DLR 1.5' && !camposOperacaoValidos)"
							@click="finalizarOperacao"
						/>
					</div>
				</div>
			</template>
		</CrudForm>

		<Modal
			v-if="visualizarDispersao"
			style="background-color: white"
		>
			<div style="display: flex; align-items: center">
				<div>
					<div
						v-if="buscandoMedicao"
						style="
							display: flex;
							justify-content: center;
							align-items: center;
							flex-direction: column;
						"
					>
						<Loading />
						<h1 style="margin: 0">
							{{ $t('buscandoMedicao') }}
						</h1>
					</div>

					<div v-else>
						<div style="display: flex; gap: 1rem">
							<i
								style="font-size: 1rem; height: fit-content; margin: auto 0; cursor: pointer"
								class="fas fa-arrow-left"
								@click="visualizarDispersao = !visualizarDispersao"
							/>
							<h1 style="margin: 0">
								{{ $t('medicaoOrdemServico') }}: OS-{{ model.orsv_cd_codigo }} -
								{{ model.orsv_ds_descricao }}
							</h1>
						</div>

						<p v-show="!buscandoMedicao">
							{{ $t('cliqueParaFazerEdicao') }}
						</p>

						<OutliersChart
							viewing
							:categorias-arvore="categorias"
							:bind-colunas="bindColunas"
							:series="dadosParaOutliersChart"
							:opcoes-eixo-x="opcoesEixoX"
							:opcoes-eixo-y="opcoesEixoY"
							@desconsiderar="desconsiderar"
							@changePoint="changePoint"
						/>

						<div class="flex justify-between">
							<UIButton
								text="voltar"
								secondary
								@click="
									visualizarDispersao = false
									showForm = true
								"
							/>
							<UIButton
								text="salvar alterações"
								:disabled="!ableToSave"
								:loading="salvandoAlteracoes"
								@click="salvarAlteracoes"
							/>
						</div>
					</div>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import Button from '../../../components/Button/Button'
import CrudForm from '../../../components/CrudForm/CrudForm'
import CrudTable from '../../../components/CrudTable/CrudTable'
import DatePicker from '../../../components/DatePicker/DatePicker'
import Dropdown from '../../../components/Dropdown/Dropdown'
import DropdownCheckbox from '../../../components/DropdownCheckbox/DropdownCheckbox'
import DropdownCheckboxFk from '../../../components/DropdownCheckboxFk/DropdownCheckboxFk'
import DropdownFk from '../../../components/DropdownFk/DropdownFk'
import InputSearch from '../../../components/InputSearch/InputSearch'
import InputText from '../../../components/InputText/InputText'
import KebabMenu from '../../../components/KebabMenu/KebabMenu'
import Loading from '../../../components/Loading/Loading'
import Modal from '../../../components/Modal/Modal'
import OutliersChart from '../../../components/OutliersChart/OutliersChart'
import RadioButtons from '../../../components/RadioButtons/RadioButtons'
import Step from '../../../components/Steps/Step'
import Steps from '../../../components/Steps/Steps'
import Switcher from '../../../components/Switcher/Switcher'
import Tab from '../../../components/Tab/Tab'
import Tag from '../../../components/Tag/Tag'
import UIButton from '../../../components/ui/button/Button'
import SFCheckbox from '../../../components/ui/checkbox/Checkbox.vue'
import SFMessage from '../../../components/ui/message/Message.vue'
import ToggleSwitch from '../../../components/ui/switch/ToggleSwitch.vue'
import { useMessages } from '../../../composables/useMessages'
import ShapeFileUpload from '../../Cadastros/Florestal/Fazenda/ImportShape/ShapeFileUpload/ShapeFileUpload.vue'
const { addMessage } = useMessages()

import ControllingPaginationMixins from '../../../mixins/ControllingPaginationMixins'
import MedicaoesInventarioMixins from '../../../mixins/MedicaoesInventarioMixins'
import PlanejamentoOrdemDeServicoMixins from '../../../mixins/PlanejamentoOrdemDeServicoMixins'
import RegistersMixins from '../../../mixins/RegistersMixins'

import { TheMask } from 'vue-the-mask'
import PlanejamentoOrdemDeServicoPilha from './PlanejamentoOrdemDeServicoPilha.vue'

import GridPagination from '../../../components/GridPagination/GridPagination.vue'
import Tooltip from '../../../components/ui/tooltip/Tooltip.vue'
import {
	getDadosValidacaoConsistencia,
	getDropdownMedicaoPorEstratoFlorestal,
} from '../../../services/requests/MedicoesInventarioRequests'
import {
	buscarDropdownValidacaoConsistencia,
	createOrdemDeServico,
	deleteOrdemDeServicoByIdList,
	fecharOrdemServico,
	getAllOrdensDeServicos,
	getColetaInfo,
	getDropdowns,
	openOrdemServico,
	savePlanejamentoInstalacaoCLR,
	unblockOrdemServico,
	updateOrdemDeServico,
} from '../../../services/requests/OrdemDeServicoRequests'
import PlanejamentoOrdemServico from './PlanejamentoOrdemServico.vue'

import { ordemDeServicoSingleTreesPlanejar } from '../../../services/requests/PlanejamentoDeOrdemDeServicoSingleTreesRequests'
import { ordemDeServicoTradicionalPlanejar } from '../../../services/requests/PlanejamentoDeOrdemDeServicoTradicionalRequests'

import { mapGetters } from 'vuex'
import { recuperaDispersao } from '../../../services/requests/ArvoreRequests'
import { getDropdownEstratosFlorestais } from '../../../services/requests/EstratoFlorestalRequests'
import { getDropdownExecutores } from '../../../services/requests/ExecutorRequests'

import { tiposDeOrdensDeServico } from '../../../constants/Mappings/TiposDeOrdensDeServico'

import { exportarCsv } from '../../../utils/csvHellpers'
import { outliersMessage } from '../../../utils/enums/OutliersMessage'

import { Icon } from '@iconify/vue2'
import download from 'downloadjs'
import ExclusionAlert from '../../../components/ExclusionAlert/ExclusionAlert.vue'

export default {
	name: 'OrdemServico',

	components: {
		Icon,
		PlanejamentoOrdemDeServicoPilha,
		Steps,
		Step,
		KebabMenu,
		GridPagination,
		Button,
		CrudForm,
		CrudTable,
		ShapeFileUpload,
		DatePicker,
		Loading,
		SFMessage,
		Tab,
		Dropdown,
		Switcher,
		DropdownCheckbox,
		Tooltip,
		DropdownCheckboxFk,
		DropdownFk,
		Tag,
		InputSearch,
		InputText,
		OutliersChart,
		PlanejamentoOrdemServico,
		Modal,
		UIButton,
		ExclusionAlert,
		ToggleSwitch,
		SFCheckbox,
		RadioButtons,
	},
	directives: {
		TheMask,
	},

	computed: {
		showDataConsistencySwitcher() {
			return (
				this.model.fk_tpsv_tipo_servico &&
				(this.codigoTipoServico === '002' || this.codigoTipoServico === '003')
			)
		},

		isSelectedStratumContinuous() {
			return (
				this.estratosFlorestais.find(
					(estrato) => estrato.id === this.model.fk_esfl_estrato_florestal,
				)?.esfl_is_traditional || false
			)
		},
		tiposDeServicoComputados() {
			return this.tiposDeServico
				.filter((tipo) =>
					['001', '002', '003', '007', '008', '005', '018', '019'].includes(tipo.codigo),
				)
				.map((tipo) => {
					return {
						label: `${tipo.codigo} - ${tipo.descricao}`,
						value: tipo.id,
						disabled: tipo.codigo === '005' && this.medicoesDoEstrato.length === 0,
					}
				})
		},
		nomeFazenda() {
			const estrato = this.estratosFlorestais.find(
				(estrato) =>
					estrato.id ===
					this.modelList.find((m) => m.isCheckedToDelete === true).fk_esfl_estrato_florestal,
			)
			return estrato ? estrato.fzda_nm_nome : null
		},
		dateDataDeInicioOs() {
			return new Date(this.model.orsv_dt_data_inicial)
		},
		dateDataDePrazoExecucao() {
			return new Date(this.model.orsv_dt_prazo_final)
		},
		tituloDoFormulario() {
			if (this.mostrarInventarioDePilha) return 'Planejamento'
			if (this.mostrarOperacao) {
				return this.isEdit
					? `${this.$t('edit')} ${this.$t('operation')}`
					: `${this.$t('create')} ${this.$t('operation')}`
			}
			return this.isEdit
				? `${this.$t('edit')} ${this.$t('serviceOrder')}`
				: `${this.$t('create')} ${this.$t('serviceOrder')}`
		},
		descricaoEstratoFlorestalFormulario() {
			return this.estratosFlorestais.find((f) => f.id === this.model.fk_esfl_estrato_florestal)
				.esfl_ds_descricao
		},
		isSupportMode() {
			return localStorage.getItem('supportMode')
		},
		...mapGetters('moduleImportShape', [
			'getGeoJsonFzda',
			'getGeoJsonTlho',
			'getGeoJsonPtio',
			'getGeoJsonPrcla',
			'isGeoJsonParcelaEmpty',
		]),

		// Apenas disponibiliza quando a ordem de servico for tradicional, ou caso seja single trees e possua numero de fustes
		disponibilizarSwitcherDeCoeficienteDeVariacao() {
			return (
				this.model.tpsv_cd_codigo === '001' ||
				this.model.tpsv_cd_codigo === '002' ||
				this.model.tpsv_cd_codigo === '003' ||
				this.model.tpsv_cd_codigo === '019' ||
				(this.model.tpsv_cd_codigo === '007' && this.numeroDeFustes)
			)
		},

		instalacaoSingleTreesEJaPossuiAmostraSalva() {
			return (
				this.model.tpsv_cd_codigo === '007' &&
				this.parcelas.filter((amostra) => amostra.existente).length > 0
			)
		},

		blocked() {
			return this.modelList.filter((f) => f.orsv_is_blocked)
		},

		estratosFormatados() {
			return this.estratosFlorestais
				.filter((estrato) => estrato.estratoFoiPlanejado)
				.map((estrato) => {
					return Object.assign(estrato, {
						[this.$t('description')]: estrato.esfl_ds_descricao,
						[this.$t('code')]: estrato.esfl_cd_codigo,
						[this.$t('farm')]: estrato.fzda_nm_nome,
						[`${this.$t('type')}`]: estrato.esfl_is_traditional
							? this.$t('continuous')
							: `${this.$t('temporary')} (${this.$t('spot')})`,
					})
				})
		},

		dropdownConsistencia() {
			return this.inventariosConsistencia.map((inventario) => {
				return {
					id: inventario.id,
					[this.$t('code')]: inventario.codigo,
					[this.$t('description')]: inventario.descricao,
					[this.$t('farm')]: inventario.nomeFazenda,
					[this.$t('type')]: inventario.tipoOrdemServico,
				}
			})
		},

		kebabOptionsOrdemServico() {
			return [
				{
					value: `toggleInfoPlantio-${this.togglePlantio ? 'off' : 'on'}`,
					label: `${
						this.togglePlantio ? this.$t('hide') : this.$t('show')
					} ${this.$t('plantingInfo')}`,
				},
				{
					value: 'downloadFazenda',
					label: this.$t('downloadFazenda'),
				},
				{
					value: 'downloadTalhao',
					label: this.$t('downloadTalhao'),
				},
				{
					value: 'downloadPlantio',
					label: this.$t('downloadPlantio'),
				},
				{
					value: 'downloadParcela',
					label: this.$t('downloadParcela'),
				},
			]
		},

		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},

		codigoTipoServico() {
			return this.tiposDeServicoComputados
				.find((f) => f.value === this.model.fk_tpsv_tipo_servico)
				.label.split('-')[0]
				.trim()
		},

		marcador() {
			return this.isSingleTrees
				? this.$t('sample')
				: this.codigoTipoServico === '009'
					? this.$('concentrator')
					: this.$t('plot')
		},

		isDropdownTiposServicoDisable() {
			if (
				this.model.fk_esfl_estrato_florestal === '' ||
				this.model.fk_esfl_estrato_florestal === undefined
			)
				return false

			let estratoFlorestal = this.estratosFlorestais.find(
				(estratoFlorestal) => estratoFlorestal.id === this.model.fk_esfl_estrato_florestal,
			)

			return this.isEdit || estratoFlorestal['Continuo?'] === this.$t('no')
		},

		parcelaProperties: {
			get: function () {
				let properties = this.getGeoJsonPrcla.properties
				return Object.keys(this.getGeoJsonPrcla).length === 0
					? []
					: Object.entries(properties).map((m) => {
							return {
								label: `${m[0]}: ${m[1]}`,
								value: m[0],
							}
						})
			},

			set: function (value) {
				this.codigoParcela = value
			},
		},

		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			const camposObrigatoriosEmComum =
				this.model.fk_esfl_estrato_florestal !== '' &&
				this.model.fk_tpsv_tipo_servico !== '' &&
				this.model.orsv_dt_data_inicial !== '' &&
				this.model.orsv_dt_prazo_final !== '' &&
				this.model.orsv_ds_descricao !== ''

			const tiposDeServicoObrigatorios = ['001', '002', '003', '019']
			if (tiposDeServicoObrigatorios.includes(this.model.tpsv_cd_codigo)) {
				return camposObrigatoriosEmComum && this.model.orsv_tx_forma_parcela !== ''
			}

			if (this.model.verificarConsistencia && this.isSelectedStratumContinuous) {
				return camposObrigatoriosEmComum && this.model.inventarioReferencia === ''
			}

			return camposObrigatoriosEmComum
		},

		/**
		 * Valida se os campos da etapa Operação estão preenchidos
		 */
		camposOperacaoValidos() {
			// Força a propriedade computada a reagir a mudanças
			const trigger = this.validationTrigger

			// Para OS 007 em edição, apenas valida os dropdowns (data e hora estão desabilitados)
			if (this.isEdit && this.model.tpsv_cd_codigo === '007') {
				// Só habilita se o usuário tiver interagido com os dropdowns
				if (!this.usuarioAlterouDropdownOperacao) {
					return false
				}

				const dropdownsPreenchidos = (
					this.model.orsv_tx_frequencia_coleta !== '' &&
					this.model.orsv_tx_periodo_disponivel !== ''
				)

				if (!dropdownsPreenchidos) {
					return false
				}

				// Verifica se houve mudanças nos dropdowns
				const houveAlteracao = (
					this.model.orsv_tx_frequencia_coleta !== this.dadosOperacaoOriginais.orsv_tx_frequencia_coleta ||
					this.model.orsv_tx_periodo_disponivel !== this.dadosOperacaoOriginais.orsv_tx_periodo_disponivel
				)
				return houveAlteracao
			}

			// Para os demais casos, verifica se todos os campos estão preenchidos
			const todosPreenchidos = (
				this.model.orsv_dt_hora_inicio_medicao !== '' &&
				this.model.orsv_tx_frequencia_coleta !== '' &&
				this.model.orsv_tx_periodo_disponivel !== '' &&
				this.horaInicio !== '' &&
				this.fusoHorario !== ''
			)

			// Se não estiver preenchido, desabilita o botão
			if (!todosPreenchidos) {
				return false
			}

			// Se for edição (outros tipos), verifica se houve mudanças em todos os campos
			if (this.isEdit) {
				const houveAlteracao = (
					this.model.orsv_dt_hora_inicio_medicao !== this.dadosOperacaoOriginais.orsv_dt_hora_inicio_medicao ||
					this.model.orsv_tx_frequencia_coleta !== this.dadosOperacaoOriginais.orsv_tx_frequencia_coleta ||
					this.model.orsv_tx_periodo_disponivel !== this.dadosOperacaoOriginais.orsv_tx_periodo_disponivel ||
					this.horaInicio !== this.dadosOperacaoOriginais.horaInicio ||
					this.fusoHorario !== this.dadosOperacaoOriginais.fusoHorario
				)
				return houveAlteracao
			}

			// Se for cadastro, apenas valida se está preenchido
			return true
		},

		/**
		 * Verifica se a OS é do tipo Instalação (007) E Single Trees
		 * Apenas OSs de instalação Single Trees (007 + isSingleTrees) precisam passar pela etapa de Operação
		 */
		isOrdemServicoInstalacao() {
			return this.model.tpsv_cd_codigo === '007' && this.isSingleTrees
		},

		/**
		 * Verifica se os campos de Operação devem estar desabilitados
		 * Para OS tipo 008 em modo de edição com versão do dendrômetro já definida, os campos devem estar desabilitados.
		 * Se a versão ainda não foi definida (OS pausada antes de finalizar a etapa de Operação), os campos ficam editáveis.
		 */
		camposOperacaoDesabilitados() {
			return (
				this.model.tpsv_cd_codigo === '008' &&
				this.isEdit &&
				!!this.versaoDendrometroOriginalAoEditar
			)
		},

		/**
		 * Verifica se os campos de data e hora devem estar desabilitados
		 * Para OS tipo 007 em modo de edição com versão do dendrômetro já definida ao entrar em edição, data e hora devem estar desabilitados.
		 * Se a versão ainda não foi definida ao entrar em edição (OS pausada antes de finalizar a etapa de Operação), os campos ficam editáveis mesmo após o usuário escolher uma versão agora.
		 */
		camposDataHoraDesabilitados() {
			return (
				this.model.tpsv_cd_codigo === '007' &&
				this.isEdit &&
				!!this.versaoDendrometroOriginalAoEditar
			)
		},

		/**
		 *Tipos de servico que devem mostrar os campos referentes a parcela
		 */
		showCamposDeParcela() {
			const tipoDeServico = this.tiposDeServicoComputados.find(
				(f) => f.value === this.model.fk_tpsv_tipo_servico,
			)

			return (
				tipoDeServico?.label.startsWith('001') ||
				tipoDeServico?.label.startsWith('002') ||
				tipoDeServico?.label.startsWith('003') ||
				tipoDeServico?.label.startsWith('009')
			)
		},
		/**
		 * Tipos de servico que devem mostrar os campos referentes a geofence
		 */
		showCampoDeGeofence() {
			const tipoDeServico = this.tiposDeServicoComputados.find(
				(f) => f.value === this.model.fk_tpsv_tipo_servico,
			)
			return (
				this.showCamposDeParcela ||
				tipoDeServico?.label.startsWith('005') ||
				tipoDeServico?.label.startsWith('007')
			)
		},
		/**
		 * Retorna se existem usuarios selecionados no dropdowncheckbox que estao bloqueados
		 * mas foram selecionados para esta ordem de servico
		 */
		temUsuarioBloqueadoSelecionado() {
			return this.executores
				.filter((executor) => this.executoresSelecionados.includes(executor.id))
				.map((m) => m.Bloqueado)
				.some((Bloqueado) => Bloqueado)
		},

		/**
		 * Opções traduzidas para frequência de coleta
		 */
		frequenciaColetaOptions() {
			return [
				{ value: 'Diária', label: this.$t('daily') },
				{ value: 'A cada 2 dias', label: this.$t('every2Days') },
				{ value: 'A cada 3 dias', label: this.$t('every3Days') },
			]
		},

		/**
		 * Opções traduzidas para período disponível
		 */
		periodoDisponivelOptions() {
			return [
				{ value: 'Mensal', label: this.$t('monthly') },
				{ value: 'Bimestral', label: this.$t('bimonthly') },
				{ value: 'Trimestral', label: this.$t('quarterly') },
			]
		},
	},
	watch: {
		'model.verificarConsistencia': function (value) {
			if (value && this.isSelectedStratumContinuous) {
				buscarDropdownValidacaoConsistencia(this.model.fk_esfl_estrato_florestal).then(
					(response) => {
						this.inventariosConsistencia = response.data.result

						if (!this.inventariosConsistencia.length) {
							addMessage({
								description:
									'Não existem inventários anteriores para esse estrato. Por favor, selecione um novo estrato',
								type: 'error',
							})
							setTimeout(() => {
								this.model.verificarConsistencia = false
							}, 500)
						}
					},
				)
			}
		},
		'model.orsv_tx_frequencia_coleta': function (value, oldValue) {
			// Watcher frequencia_coleta

			// Evita loop infinito quando está atualizando o período
			if (this.atualizandoDropdownOperacao) {
				
				return
			}

			// Não faz nada se o valor não mudou de verdade
			if (value === oldValue) {
				
				return
			}

			// Regra de preenchimento automático do período disponível baseado na frequência
			const frequenciaToPeriodo = {
				'Diária': 'Mensal',
				'A cada 2 dias': 'Bimestral',
				'A cada 3 dias': 'Trimestral'
			}

			if (value && frequenciaToPeriodo[value]) {

				this.atualizandoDropdownOperacao = true
				this.$set(this.model, 'orsv_tx_periodo_disponivel', frequenciaToPeriodo[value])
				this.$nextTick(() => {
					this.atualizandoDropdownOperacao = false

				})
			}
		},
		'model.orsv_tx_periodo_disponivel': function (value, oldValue) {
			// Watcher periodo_disponivel

			// Evita loop infinito quando está atualizando a frequência
			if (this.atualizandoDropdownOperacao) {

				return
			}

			// Não faz nada se o valor não mudou de verdade
			if (value === oldValue) {

				return
			}

			// Regra de preenchimento automático da frequência baseada no período disponível
			const periodoToFrequencia = {
				'Mensal': 'Diária',
				'Bimestral': 'A cada 2 dias',
				'Trimestral': 'A cada 3 dias'
			}

			if (value && periodoToFrequencia[value]) {

				this.atualizandoDropdownOperacao = true
				this.$set(this.model, 'orsv_tx_frequencia_coleta', periodoToFrequencia[value])
				this.$nextTick(() => {
					this.atualizandoDropdownOperacao = false

				})
			}
		},
		'model.orsv_dt_hora_inicio_medicao': function (value, oldValue) {
			// Não faz nada se o valor não mudou
			if (value === oldValue) {
				return
			}
			// Incrementa o trigger apenas em modo de edição para forçar recálculo da validação
			if (this.isEdit) {
				this.validationTrigger++
			}
		},
		horaInicio: function (value, oldValue) {
			// Não faz nada se o valor não mudou
			if (value === oldValue) {
				return
			}
			// Incrementa o trigger apenas em modo de edição para forçar recálculo da validação
			if (this.isEdit) {
				this.validationTrigger++
			}
		},
		intentionOrdemServico(value) {
			const intentionsMapped = {
				downloadFazenda: this.actionDownloadFazenda,
				downloadTalhao: this.actionDownloadTalhao,
				downloadPlantio: this.actionDownloadPlantio,
				'toggleInfoPlantio-on': () => (this.togglePlantio = !this.togglePlantio),
				'toggleInfoPlantio-off': () => (this.togglePlantio = !this.togglePlantio),
				downloadParcela: this.baixarGeoJsonParcela,
			}

			if (value.intent) intentionsMapped[value.intent]()
		},

		searchQuery(value) {
			const pageNumber = 0
			const pageSize = 0
			this.refreshTabela(pageNumber, pageSize, value)
			this.$refs.ref__pagination.resetToFirstPageInputHandle()
		},

		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		intention(value) {
			const model = this.modelList.find((model) => {
				return model.id === value.properties.id
			})
			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
				case 'abrirOS':
					openOrdemServico(model.id)
						.then(() => {
							const indexOrdemDeServico = this.modelList
								.map((ordemDeServico) => ordemDeServico.id)
								.indexOf(value.properties.id)

							var ordemDeServico = this.modelList[indexOrdemDeServico]
							ordemDeServico.orsv_dt_data_final = null
							ordemDeServico.finalizacaoDaOs = ''

							this.modelList.splice(indexOrdemDeServico, 1, ordemDeServico)

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
						})
						.catch(() => {
							this.mutationShowMessage({
								messageTitle: this.$t('erro'),
								messageText: this.$t('erroAoAbrirOS'),
								messageIcon: 'far fa-check-circle',
								messageType: 'error',
							})
						})
					break
				case 'fecharOS':
					fecharOrdemServico(model.id)
						.then(() => {
							const indexOrdemDeServico = this.modelList
								.map((ordemDeServico) => ordemDeServico.id)
								.indexOf(value.properties.id)

							const dataAtual = new Date()
							const dia = String(dataAtual.getDate()).padStart(2, '0')
							const mes = String(dataAtual.getMonth() + 1).padStart(2, '0')
							const ano = dataAtual.getFullYear()
							const dataFormatada = `${dia}/${mes}/${ano}`

							var ordemDeServico = this.modelList[indexOrdemDeServico]
							ordemDeServico.orsv_dt_data_final = `${dataFormatada}T00:00:00`
							ordemDeServico.finalizacaoDaOs = dataFormatada

							this.modelList.splice(indexOrdemDeServico, 1, ordemDeServico)

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
						})
						.catch(() => {
							this.mutationShowMessage({
								messageTitle: this.$t('erro'),
								messageText: this.$t('erroAoAbrirOS'),
								messageIcon: 'far fa-check-circle',
								messageType: 'error',
							})
						})
					break
				case 'visualizarDispersao':
					this.buscandoMedicao = true
					this.visualizarDispersao = true
					recuperaDispersao(model.fk_mdco_medicao).then((response) => {
						if (response.data.result.length === 0) {
							addMessage({
								description: 'Não existem árvores cadastradas para essa medição',
								type: 'warning',
							})
							this.buscandoMedicao = false
							this.visualizarDispersao = false
						} else {
							this.arvores = response.data.result
							this.buscandoMedicao = false
							this.model = Object.assign({}, model)
							this.colunaAtributo = this.colunasMapeamento.map((coluna) => {
								return {
									coluna: coluna.nome,
									value: coluna.key,
									key: coluna.key,
								}
							})
						}
					})

					getDadosValidacaoConsistencia(model.fk_mdco_medicao).then((response) => {
						this.dadosValidacaoConsistencia = response.data
					})
					break

				case 'unblockOS':
					unblockOrdemServico(model.id).then(() => {
						this.modelList.forEach((f) => {
							if (f.id === model.id) {
								f.orsv_is_blocked = null
							}
						})

						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})
					})
					break
			}
		},
		inventariosConsistencia: {
			handler(value) {
				if (!value.length) {
					this.model.verificarConsistencia = false
				}
			},
			immediate: false,
		},
		'model.fk_esfl_estrato_florestal': function (value) {
			if (value) {
				let estratoFlorestal = this.estratosFlorestais.find(
					(estratoFlorestal) => estratoFlorestal.id === value,
				)
				if (estratoFlorestal['Continuo?'] === this.$t('no')) {
					let tipoServico = this.tiposDeServicoComputados.find((tipoServico) =>
						tipoServico.label.startsWith('003'),
					)
					this.model.fk_tpsv_tipo_servico = tipoServico.value
				}

				getDropdownMedicaoPorEstratoFlorestal(value).then((response) => {
					this.medicoesDoEstrato = response
				})
			}
		},

		/**
		 * Sempre que mudar o tipo de servico zerar os valores que devem ser preenchidos
		 * que não são comuns a todas as ordens de servico, porém se for uma edição
		 * não deve zerar os valores, pois caso contrário ao setar o model e
		 * abrir o formulario, ele virá com essas informações vazias
		 */
		'model.fk_tpsv_tipo_servico': function (id) {
			if (id && !this.isEdit) {
				this.model.tpsv_cd_codigo = this.tiposDeServicoComputados
					.find((f) => f.value === id)
					.label.split('-')[0]
					.trim()
				// this.model.orsv_md_medida_parcela = null
				// this.model.orsv_tx_forma_parcela = ""
				// this.model.orsv_md_geofence = null
			}
		},
	},
	destroyed() {
		localStorage.removeItem('supportMode')
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [
		ControllingPaginationMixins,
		RegistersMixins,
		MedicaoesInventarioMixins,
		PlanejamentoOrdemDeServicoMixins,
	],
	data() {
		return {
			inventariosConsistencia: [],

			showDeleteConfirmationPopup: false,
			error: false,
			errorParcela: false,
			generationType: 1,
			componentKey: 0,
			executoresSelecionadosColeta: [],
			estratosSelecionados: [],
			codigosOrdensServico: [],
			loteSingleTrees: false,
			planejamentoCubagem: false,
			salvandoPlanejamento: false,
			buscandoMedicao: false,
			visualizarDispersao: false,
			intention: {},
			searchQuery: '',
			exportando: false,
			intentionOrdemServico: {},
			headersSelecionados: [
				'orsv_cd_codigo',
				'esfl_ds_descricao',
				'orsv_ds_descricao',
				'tipoDeServico',
				'dataInicial',
				'finalizacaoDaOs',
				'amostras',
				'orsv_md_progresso',
			],
			metodologiasAmostrais: [
				{ label: this.$t('sistematic'), value: 'Sistematico' },
				{
					label: this.$t('twoStagesRandom'),
					value: 'AleatorioSistematico',
				},
				{ label: this.$t('random'), value: 'Aleatorio' },
			],
			togglePlantio: false,
			codigoParcela: undefined,

			codParcela: [],
			btnLanca: false,
			filtroConfig: {
				selectedCodigosParcelas: [],
			},
			mostrarMapaPlantio: false,
			mostrarInventarioDePilha: false,
			mostrarOperacao: false,
			versaoDendrometroOriginalAoEditar: '',
			horaInicio: '',
			fusoHorario: '',
			dadosOperacaoOriginais: {
				orsv_dt_hora_inicio_medicao: '',
				orsv_tx_frequencia_coleta: '',
				orsv_tx_periodo_disponivel: '',
				horaInicio: '',
				fusoHorario: ''
			},
			atualizandoDropdownOperacao: false,
			dropdownKey: 0,
			validationTrigger: 0,
			usuarioAlterouDropdownOperacao: false,
			fusosHorarios: [
				{ value: 'Pacific/Midway', label: '(UTC-11:00) Midway Island' },
				{ value: 'Pacific/Honolulu', label: '(UTC-10:00) Hawaii' },
				{ value: 'America/Anchorage', label: '(UTC-09:00) Alaska' },
				{ value: 'America/Los_Angeles', label: '(UTC-08:00) Pacific Time (US & Canada)' },
				{ value: 'America/Denver', label: '(UTC-07:00) Mountain Time (US & Canada)' },
				{ value: 'America/Chicago', label: '(UTC-06:00) Central Time (US & Canada)' },
				{ value: 'America/Mexico_City', label: '(UTC-06:00) Mexico City' },
				{ value: 'America/New_York', label: '(UTC-05:00) Eastern Time (US & Canada)' },
				{ value: 'America/Bogota', label: '(UTC-05:00) Bogota, Lima' },
				{ value: 'America/Caracas', label: '(UTC-04:00) Caracas' },
				{ value: 'America/Halifax', label: '(UTC-04:00) Atlantic Time (Canada)' },
				{ value: 'America/Manaus', label: '(UTC-04:00) Manaus (Amazonas)' },
				{ value: 'America/Cuiaba', label: '(UTC-04:00) Cuiabá (Mato Grosso)' },
				{ value: 'America/Campo_Grande', label: '(UTC-04:00) Campo Grande (Mato Grosso do Sul)' },
				{ value: 'America/Sao_Paulo', label: '(UTC-03:00) Brasília, São Paulo, Rio de Janeiro' },
				{ value: 'America/Bahia', label: '(UTC-03:00) Salvador (Bahia)' },
				{ value: 'America/Fortaleza', label: '(UTC-03:00) Fortaleza (Ceará)' },
				{ value: 'America/Recife', label: '(UTC-03:00) Recife (Pernambuco)' },
				{ value: 'America/Belem', label: '(UTC-03:00) Belém (Pará)' },
				{ value: 'America/Maceio', label: '(UTC-03:00) Maceió (Alagoas)' },
				{ value: 'America/Argentina/Buenos_Aires', label: '(UTC-03:00) Buenos Aires' },
				{ value: 'America/Noronha', label: '(UTC-02:00) Fernando de Noronha' },
				{ value: 'America/Eirunepe', label: '(UTC-05:00) Rio Branco (Acre)' },
				{ value: 'Atlantic/Azores', label: '(UTC-01:00) Azores' },
				{ value: 'UTC', label: '(UTC+00:00) Coordinated Universal Time' },
				{ value: 'Europe/London', label: '(UTC+00:00) London, Dublin' },
				{ value: 'Europe/Paris', label: '(UTC+01:00) Paris, Amsterdam, Berlin' },
				{ value: 'Europe/Rome', label: '(UTC+01:00) Rome, Madrid' },
				{ value: 'Africa/Cairo', label: '(UTC+02:00) Cairo' },
				{ value: 'Europe/Athens', label: '(UTC+02:00) Athens, Istanbul' },
				{ value: 'Africa/Johannesburg', label: '(UTC+02:00) Johannesburg' },
				{ value: 'Europe/Moscow', label: '(UTC+03:00) Moscow, St. Petersburg' },
				{ value: 'Asia/Dubai', label: '(UTC+04:00) Abu Dhabi, Dubai' },
				{ value: 'Asia/Karachi', label: '(UTC+05:00) Islamabad, Karachi' },
				{ value: 'Asia/Kolkata', label: '(UTC+05:30) Mumbai, Kolkata, Chennai' },
				{ value: 'Asia/Dhaka', label: '(UTC+06:00) Dhaka' },
				{ value: 'Asia/Bangkok', label: '(UTC+07:00) Bangkok, Hanoi, Jakarta' },
				{ value: 'Asia/Shanghai', label: '(UTC+08:00) Beijing, Shanghai' },
				{ value: 'Asia/Hong_Kong', label: '(UTC+08:00) Hong Kong' },
				{ value: 'Asia/Singapore', label: '(UTC+08:00) Singapore' },
				{ value: 'Asia/Tokyo', label: '(UTC+09:00) Tokyo, Osaka' },
				{ value: 'Asia/Seoul', label: '(UTC+09:00) Seoul' },
				{ value: 'Australia/Sydney', label: '(UTC+10:00) Sydney, Melbourne' },
				{ value: 'Pacific/Guadalcanal', label: '(UTC+11:00) Solomon Islands' },
				{ value: 'Pacific/Auckland', label: '(UTC+12:00) Auckland, Wellington' },
			],
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			ns: 0.05,
			N: 0,
			cv_perc: 0,
			ic_perc: 0,
			n: 0,
			isResumo: false,

			valueSelected: {
				menu: [
					{
						key: 'editar',
						value: this.$t('edit'),
						isActive: false,
					},
					{ key: 'planejamento', value: this.$t('planning'), isActive: false },
					{ key: 'resumo', value: this.$t('summary'), isActive: false },
					{
						key: 'dispersao',
						value: this.$t('visualizeDispersion'),
						isActive: false,
					},
					{ key: 'abrir', value: this.$t('openOS'), isActive: false },
					{ key: 'fechar', value: this.$t('closeOS'), isActive: false },
				],
			},
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				prefix: 'OS',
				subtitleCardPropertie: 'orsv_ds_descricao',
				titleCardPropertie: 'orsv_cd_codigo',
				progressBar: ['orsv_md_progresso'],
			},

			tableHeaders: [
				{ key: 'orsv_cd_codigo', value: this.$t('code'), isActive: true },
				{
					key: 'esfl_ds_descricao',
					value: this.$t('forestStratification'),
					isActive: true,
				},
				{
					key: 'orsv_ds_descricao',
					value: this.$t('description'),
					isActive: true,
				},
				{
					key: 'tipoDeServico',
					value: this.$t('serviceType'),
					isActive: true,
				},
				{
					key: 'dataInicial',
					value: this.$t('startDate'),
					isActive: true,
				},
				{
					key: 'finalizacaoDaOs',
					value: this.$t('finalDate'),
					isActive: true,
				},
				{ key: 'prazoFinal', value: this.$t('deadline'), isActive: false },
				{
					key: 'amostras',
					value: this.$t('samples'),
					isActive: true,
				},
				{
					key: 'orsv_md_progresso',
					value: 'Progresso',
					isActive: true,
				},
			],

			/**
			 *Estratos florestais cadastrados no banco de dados
			 */
			estratosFlorestais: [],

			/**
			 * Medições relacionadas ao estrato escolhido, salva-se para verificar se
			 * é possível criar uma OS de coleta de cubagem. Coleta de cubagem precisa
			 * que medições existam no estrato
			 */
			medicoesDoEstrato: [],

			/**
			 *Todos os Executores cadastrados no banco de dados
			 */
			executores: [],

			/**
			 *Tipos de Servicos cadastrados no banco de dados
			 */
			tiposDeServico: [],

			/**
			 * ExecutoresSelecionados para DropdownCheckboxFk
			 */
			executoresSelecionados: [],

			/**
			 * Mensagem de intensidade amostral
			 */
			mensagemDeIntensidadeAmostral: '',
		}
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	created() {
		this.quantityPerPage = 10
		this.orderTable = ['orsv_cd_codigo']

		const ordensServicoParam = this.$route.query.ordens_servico
			? JSON.parse(decodeURIComponent(this.$route.query.ordens_servico))
			: []

		const pageNumber = 0
		const pageSize = 0

		if (ordensServicoParam.length > 0) {
			this.codigosOrdensServico = ordensServicoParam
				.map((ordem) => ordem.split(' - ')[0])
				.join('@@')
			getDropdownEstratosFlorestais().then((response) => {
				this.estratosFlorestais = response

				getDropdowns().then((response) => {
					this.tiposDeServico = response.data.result.tiposDeServicos
					this.refreshTabela(pageNumber, pageSize, this.codigosOrdensServico)
				})
			})
		} else {
			getDropdownEstratosFlorestais().then((response) => {
				this.estratosFlorestais = response

				getAllOrdensDeServicos().then((response) => {
					const { result: ordensDeServicos } = response.data

					ordensDeServicos.forEach((ordemDeServico) => {
						this.formataOrdemDeServicoParaTabela(ordemDeServico)

						switch (ordemDeServico.tpsv_cd_codigo) {
							case tiposDeOrdensDeServico.INVENTARIO_DE_INSTALACAO:
							case tiposDeOrdensDeServico.INVENTARIO_CONTINUO:
							case tiposDeOrdensDeServico.INVENTARIO_PRE_CORTE:
							case tiposDeOrdensDeServico.INVENTARIO_DE_QUALIDADE:
								ordemDeServico.orsv_md_progresso = parseFloat(
									ordemDeServico.porcentagemParcelasColetadas.toFixed(2),
								)
								break
							case tiposDeOrdensDeServico.COLETA_DE_CUBAGEM:
								ordemDeServico.orsv_md_progresso = parseFloat(
									ordemDeServico.porcentagemArvoresCubadas.toFixed(2),
								)
								break
							case tiposDeOrdensDeServico.INSTALACAO_SINGLE_TREES:
								ordemDeServico.orsv_md_progresso = parseFloat(
									ordemDeServico.porcentagemAmostrasInstaladasSingleTrees.toFixed(2),
								)
								break
							case tiposDeOrdensDeServico.COLETA_SINGLE_TREES:
								ordemDeServico.orsv_md_progresso = parseFloat(
									ordemDeServico.porcentagemAmostrasColetadasSingleTrees.toFixed(2),
								)
								break
							case tiposDeOrdensDeServico.INSTALACAO_DE_DENDROMETROS:
								ordemDeServico.orsv_md_progresso = parseFloat(
									ordemDeServico.porcentagemConcentradoresInstaladosHighPrecisionLongRange.toFixed(
										2,
									),
								)
								break
							case tiposDeOrdensDeServico.COLETA_HIGH_PRECISION:
								ordemDeServico.orsv_md_progresso = parseFloat(
									ordemDeServico.porcentagemConcentradoresColetadosHighPrecisionLongRange.toFixed(
										2,
									),
								)
								break
							case tiposDeOrdensDeServico.INVENTARIO_DE_PILHA:
								ordemDeServico.orsv_md_progresso = parseFloat(
									ordemDeServico.porcentagemOrdemDeServicoDePilha.toFixed(2),
								)
								break
							default:
								console.log('Tipo de Ordem de serviço não identificada')
						}
					})

					this.modelList = ordensDeServicos

					this.tableConfiguration.statusTable = this.$t('noRecordFound')
				})
			})

			getDropdownExecutores().then((response) => {
				this.executores = response
			})

			getDropdowns().then((response) => {
				this.tiposDeServico = response.data.result.tiposDeServicos
			})
		}

		// getDropdownCubagem().then(response => {
		//   this.estratosFlorestais.forEach(estrato => {
		//     estrato.estratoPossuiMedicao = response.find(estratoCubagem => estratoCubagem.id === estrato.id)?.estratoPossuiMedicao || false
		//   })
		// })
	},

	methods: {
		checkInventarios() {
			if (!this.inventariosConsistencia.length) {
				addMessage({
					description:
						'Não existem inventários anteriores para esse estrato. Por favor, selecione um novo estrato',
					type: 'error',
				})
				this.model.verificarConsistencia = false
			}
		},

		handleDataChange(value) {
			// Incrementa o trigger apenas em modo de edição para forçar recálculo do computed
			if (this.isEdit) {
				this.validationTrigger++
			}
		},

		handleHoraChange(value) {
			// Incrementa o trigger apenas em modo de edição para forçar recálculo do computed
			if (this.isEdit) {
				this.validationTrigger++
			}
		},

		handleFrequenciaChange(value) {
			// Atualiza o valor da frequência
			this.$set(this.model, 'orsv_tx_frequencia_coleta', value)

			// Incrementa o trigger apenas em modo de edição para forçar recálculo do computed
			if (this.isEdit) {
				this.validationTrigger++
				// Marca que o usuário interagiu com os dropdowns (para OS 007)
				if (this.model.tpsv_cd_codigo === '007') {
					this.usuarioAlterouDropdownOperacao = true
				}
			}

			// Evita loop infinito
			if (this.atualizandoDropdownOperacao) {
				return
			}

			// Regra de preenchimento automático do período disponível baseado na frequência
			const frequenciaToPeriodo = {
				'Diária': 'Mensal',
				'A cada 2 dias': 'Bimestral',
				'A cada 3 dias': 'Trimestral'
			}

			if (value && frequenciaToPeriodo[value]) {
				this.atualizandoDropdownOperacao = true
				this.$set(this.model, 'orsv_tx_periodo_disponivel', frequenciaToPeriodo[value])
				this.dropdownKey++ // Força re-render dos dropdowns
				this.$nextTick(() => {
					this.atualizandoDropdownOperacao = false
				})
			}
		},

		handlePeriodoChange(value) {
			// Atualiza o valor do período
			this.$set(this.model, 'orsv_tx_periodo_disponivel', value)

			// Incrementa o trigger apenas em modo de edição para forçar recálculo do computed
			if (this.isEdit) {
				this.validationTrigger++
				// Marca que o usuário interagiu com os dropdowns (para OS 007)
				if (this.model.tpsv_cd_codigo === '007') {
					this.usuarioAlterouDropdownOperacao = true
				}
			}

			// Evita loop infinito
			if (this.atualizandoDropdownOperacao) {
				return
			}

			// Regra de preenchimento automático da frequência baseada no período disponível
			const periodoToFrequencia = {
				'Mensal': 'Diária',
				'Bimestral': 'A cada 2 dias',
				'Trimestral': 'A cada 3 dias'
			}

			if (value && periodoToFrequencia[value]) {
				this.atualizandoDropdownOperacao = true
				this.$set(this.model, 'orsv_tx_frequencia_coleta', periodoToFrequencia[value])
				this.dropdownKey++ // Força re-render dos dropdowns
				this.$nextTick(() => {
					this.atualizandoDropdownOperacao = false
				})
			}
		},

		handleFusoHorarioChange(value) {
			this.fusoHorario = value
			// Incrementa o trigger apenas em modo de edição para forçar recálculo do computed
			if (this.isEdit) {
				this.validationTrigger++
			}
		},
		
		limitInput() {
			this.model.orsv_md_medida_parcela = this.model.orsv_md_medida_parcela.replace(/[^0-9,]/g, '')
			if (this.model.orsv_md_medida_parcela.length > 11) {
				this.model.orsv_md_medida_parcela = this.model.orsv_md_medida_parcela.substring(0, 11)
			}
			let parts = this.model.orsv_md_medida_parcela.split(',')
			if (parts.length > 1 && parts[1].length > 2) {
				this.model.orsv_md_medida_parcela = `${parts[0]},${parts[1].substring(0, 2)}`
			}
		},

		toggleDeleteConfirmationPopup() {
			this.showDeleteConfirmationPopup = !this.showDeleteConfirmationPopup
		},

		/**
		 * Baixa CSV com o resultado FILTRADO COMPLETO (nao so a pagina ja
		 * carregada): busca tudo numa chamada antes de gerar o arquivo,
		 * sem mexer no estado da grid.
		 */
		async downloadCSVOrdemDeServico() {
			if (this.exportando) return
			this.exportando = true
			try {
				const filtroAtual =
					this.searchQuery || (this.codigosOrdensServico.length ? this.codigosOrdensServico : '')

				const response = await getAllOrdensDeServicos(
					0,
					Math.max(this.modelsToBeShowedAndTotalPagination.total, 100),
					filtroAtual,
				)
				const items = response.data.result || []

				// Mesma formatacao aplicada pela grid ao carregar (refreshTabela)
				items.forEach((ordemDeServico) => {
					this.formataOrdemDeServicoParaTabela(ordemDeServico)

					switch (ordemDeServico.tpsv_cd_codigo) {
						case tiposDeOrdensDeServico.INVENTARIO_DE_INSTALACAO:
						case tiposDeOrdensDeServico.INVENTARIO_CONTINUO:
						case tiposDeOrdensDeServico.INVENTARIO_PRE_CORTE:
						case tiposDeOrdensDeServico.INVENTARIO_DE_QUALIDADE:
							ordemDeServico.orsv_md_progresso = parseFloat(
								ordemDeServico.porcentagemParcelasColetadas.toFixed(2),
							)
							break
						case tiposDeOrdensDeServico.COLETA_DE_CUBAGEM:
							ordemDeServico.orsv_md_progresso = parseFloat(
								ordemDeServico.porcentagemArvoresCubadas.toFixed(2),
							)
							break
						case tiposDeOrdensDeServico.INSTALACAO_SINGLE_TREES:
							ordemDeServico.orsv_md_progresso = parseFloat(
								ordemDeServico.porcentagemAmostrasInstaladasSingleTrees.toFixed(2),
							)
							break
						case tiposDeOrdensDeServico.COLETA_SINGLE_TREES:
							ordemDeServico.orsv_md_progresso = parseFloat(
								ordemDeServico.porcentagemAmostrasColetadasSingleTrees.toFixed(2),
							)
							break
						case tiposDeOrdensDeServico.INSTALACAO_DE_DENDROMETROS:
							ordemDeServico.orsv_md_progresso = parseFloat(
								ordemDeServico.porcentagemConcentradoresInstaladosHighPrecisionLongRange.toFixed(2),
							)
							break
						case tiposDeOrdensDeServico.COLETA_HIGH_PRECISION:
							ordemDeServico.orsv_md_progresso = parseFloat(
								ordemDeServico.porcentagemConcentradoresColetadosHighPrecisionLongRange.toFixed(2),
							)
							break
						case tiposDeOrdensDeServico.INVENTARIO_DE_PILHA:
							ordemDeServico.orsv_md_progresso = parseFloat(
								ordemDeServico.porcentagemOrdemDeServicoDePilha.toFixed(2),
							)
							break
						default:
							break
					}
				})

				const cabecalhoDoCsvOrdemDeServico = [
					'Código',
					'Descrição',
					'Data de Início',
					'Finalizada',
					'Estrato Florestal',
					'Amostras',
					'Concluído (%)',
				]

				const linhas = items.map((item) => [
					item.orsv_cd_codigo,
					item.orsv_ds_descricao,
					this.converterFormatoDeData(item.orsv_dt_data_inicial),
					this.converterFormatoDeData(item.orsv_dt_data_final),
					item.esfl_ds_descricao,
					`'${item.amostras || '-'}`,
					item.orsv_md_progresso + ' %',
				])

				exportarCsv('export_ordem_de_servico', cabecalhoDoCsvOrdemDeServico, linhas)
			} finally {
				this.exportando = false
			}
		},

		converterFormatoDeData(data) {
			if (data == undefined) return ''
			data = new Date(data)
			return `${data.getDate()}/${data.getMonth() + 1}/${data.getFullYear()}`
		},

		criarLoteSingleTrees() {
			const agora = new Date()

			const ordens = this.estratosFlorestais
				.filter((f) => this.estratosSelecionados.includes(f.id))
				.map((estrato) => {
					return {
						id: uuidv4(),
						fk_tpsv_tipo_servico: this.tiposDeServicoComputados.find((f) =>
							f.label.startsWith('008'),
						).value,
						tpsv_cd_codigo: '008',
						tpsv_ds_descricao: `Coleta SingleTrees`,
						orsv_ds_descricao: `Coleta SingleTrees Automática ${estrato.esfl_ds_descricao}`,
						fk_esfl_estrato_florestal: estrato.id,
						orsv_tx_forma_parcela: 'Circular',
						executoresIds: this.executoresSelecionadosColeta,
						orsv_dt_data_inicial: agora.toLocaleDateString('pt-BR').split('-').reverse().join('/'),
						orsv_dt_prazo_final: new Date(agora.setDate(agora.getDate() + 7))
							.toLocaleDateString('pt-BR')
							.split('-')
							.reverse()
							.join('/'),
					}
				})

			ordens.forEach((ordem) => {
				createOrdemDeServico(ordem).then(() => {
					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				})
			})
		},

		validateInput() {
			const inputValue = this.geofenceInput
			const onlyDigits = /^\d+$/.test(inputValue)
			this.error = !onlyDigits
		},

		validateInputParcela() {
			const inputValue = this.inputParcela
			const onlyDigits = /^\d+$/.test(inputValue)
			this.errorParcela = !onlyDigits
		},

		kebabOptions(ordemDeServico) {
			var options = [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]

			if (ordemDeServico.orsv_is_blocked) {
				options.push({ value: 'unblockOS', label: this.$t('unblockOS') })
			}

			if (ordemDeServico.orsv_dt_data_final == null)
				options.push({ value: 'fecharOS', label: this.$t('closeOrder') })
			else options.push({ value: 'abrirOS', label: this.$t('openOrder') })

			if (
				ordemDeServico.tpsv_cd_codigo === tiposDeOrdensDeServico.INVENTARIO_DE_INSTALACAO ||
				ordemDeServico.tpsv_cd_codigo === tiposDeOrdensDeServico.INVENTARIO_CONTINUO ||
				ordemDeServico.tpsv_cd_codigo === tiposDeOrdensDeServico.INVENTARIO_PRE_CORTE ||
				tiposDeOrdensDeServico.INVENTARIO_DE_QUALIDADE === ordemDeServico.tpsv_cd_codigo
			) {
				options.push({
					value: 'visualizarDispersao',
					label: this.$t('visualizeDispersion'),
				})
			}

			return options
		},
		/**
		 * Abre diretamente a tela de Operações ao editar uma OS 007
		 */
		async irParaOperacoes() {
			// Se a OS já foi persistida como DLR 1.0 no backend, não há configurações para visualizar.
			// Usa o snapshot capturado em showEditModelForm para evitar bloquear re-entrada
			// quando o usuário apenas selecionou DLR 1.0 no radio e cancelou (sem salvar).
			if (this.versaoDendrometroOriginalAoEditar === 'DLR 1.0') {
				this.mutationShowMessage({
					messageIcon: 'fas fa-info-circle',
					messageType: 'info',
					messageText: this.$t('osFinalizedAsDlr10NoOperationSettings'),
				})
				return
			}

			let coletaInfo = null

			try {
				// Busca os dados de coleta salvos no backend
				const { data } = await getColetaInfo(this.model.id)
				coletaInfo = data?.result || null
			} catch (error) {
				// 404 = não há dados de operação salvos ainda
				coletaInfo = null
			}

			if (!coletaInfo) {
				// Sem dados de operação: OS pausada antes de finalizar a etapa.
				// Abre o formulário com o radio visível para o usuário escolher e finalizar.
				this.dadosOperacaoOriginais = {
					orsv_dt_hora_inicio_medicao: '',
					orsv_tx_frequencia_coleta: '',
					orsv_tx_periodo_disponivel: '',
					horaInicio: '',
					fusoHorario: ''
				}
				this.usuarioAlterouDropdownOperacao = false
				this.showForm = false
				this.mostrarOperacao = true
				return
			}

			// Atualiza o model com os dados da API
			if (coletaInfo.dataHoraInicioMedicao) {
				this.model.orsv_dt_hora_inicio_medicao = coletaInfo.dataHoraInicioMedicao

				// Extrai a hora do campo de data (formato ISO: YYYY-MM-DDTHH:MM:SS)
				if (coletaInfo.dataHoraInicioMedicao.includes('T')) {
					const partes = coletaInfo.dataHoraInicioMedicao.split('T')
					if (partes.length > 1 && partes[1]) {
						// Extrai apenas HH:MM (ignora os segundos)
						this.horaInicio = partes[1].substring(0, 5)
					}
				}
			}

			// Desabilita temporariamente os watchers para evitar loop infinito
			this.atualizandoDropdownOperacao = true

			// Converte os valores do enum do backend para os valores dos dropdowns
			if (coletaInfo.frequenciaColeta) {
				this.model.orsv_tx_frequencia_coleta = this.converterEnumParaFrequenciaColeta(
					coletaInfo.frequenciaColeta
				)
			}
			if (coletaInfo.periodoDispColeta) {
				this.model.orsv_tx_periodo_disponivel = this.converterEnumParaPeriodoDisponivel(
					coletaInfo.periodoDispColeta
				)
			}
			if (coletaInfo.fusoHorario) {
				this.fusoHorario = coletaInfo.fusoHorario
			}

			// Reabilita os watchers após carregar os dados
			this.$nextTick(() => {
				this.atualizandoDropdownOperacao = false
			})

			// Salva os valores originais para detectar mudanças em modo de edição
			this.dadosOperacaoOriginais = {
				orsv_dt_hora_inicio_medicao: this.model.orsv_dt_hora_inicio_medicao || '',
				orsv_tx_frequencia_coleta: this.model.orsv_tx_frequencia_coleta || '',
				orsv_tx_periodo_disponivel: this.model.orsv_tx_periodo_disponivel || '',
				horaInicio: this.horaInicio || '',
				fusoHorario: this.fusoHorario || ''
			}

			// Reseta o flag de interação do usuário
			this.usuarioAlterouDropdownOperacao = false

			this.showForm = false
			this.mostrarOperacao = true
		},

		verPlanejamento() {
			if (this.model.tpsv_cd_codigo != '005' && !this.isGeoJsonPlantioEmpty) {
				this.mostrarMapaPlantio = true
			} else {
				this.$router.push({
					path: '/ordemdeservico/planejamentocubagem',
					query: {
						ordemServicoId: this.model.id,
						estratoFlorestalId: this.model.fk_esfl_estrato_florestal,
						executoresIds: this.model.executoresIds,
						planejamento: JSON.stringify({
							diametroReferencia: this.model.orsv_enum_tipo_diametro_referencia || 'DAP',
							metodologiaCubagem: this.model.orsv_enum_metodologia_cubagem || 'DISTANCIAS_FIXAS',
							distanciaMedicoes:
								this.model.orsv_enum_cubagem_distancias_fixas_distancia || 'UM_METRO',
						}),
					},
				})
				//this.planejamentoCubagem = true
				this.showForm = false
			}
		},
		actionDownloadFazenda() {
			download(
				JSON.stringify(this.getGeoJsonFzda),
				`GeoJSON ${this.$t('farm')} ${this.estratosFlorestais.find((f) => f.id === this.model.fk_esfl_estrato_florestal).fzda_nm_nome} ${new Date().toLocaleDateString()}.json`,
				'application/json',
			)
		},
		actionDownloadTalhao() {
			download(
				JSON.stringify(this.getGeoJsonTlho.geojson),
				`GeoJSON ${this.$t('section')} ${this.estratosFlorestais.find((f) => f.id === this.model.fk_esfl_estrato_florestal).fzda_nm_nome} ${new Date().toLocaleDateString()}.json`,
				'application/json',
			)
		},

		actionDownloadPlantio() {
			download(
				JSON.stringify(this.getGeoJsonPtio.geojson),
				`GeoJSON ${this.$t('plantation')} ${this.estratosFlorestais.find((f) => f.id === this.model.fk_esfl_estrato_florestal).fzda_nm_nome} ${new Date().toLocaleDateString()}.json`,
				'application/json',
			)
		},

		/**
		 * Calcula o campo de intensidade amostral (Hectare/Parcela)
		 */
		calcularIntensidadeAmostral() {
			this.model.orsv_nr_intensidade_amostral = (
				this.areaEstrato / this.model.orsv_nr_amostra_total
			).toFixed(1)
		},

		/**
		 * Calcula o total de amostras de acordo com a intensidade amostral
		 */
		calcularTotalDeAmostra() {
			const intensidadeAmostral = this.model.orsv_nr_intensidade_amostral
			if (intensidadeAmostral) {
				this.model.orsv_nr_amostra_total = Number(
					(this.areaEstrato / this.model.orsv_nr_intensidade_amostral).toFixed(0),
				)
			} else {
				this.orsv_nr_amostra_total = 0
			}
		},

		handleDelete(e) {
			this.parcelasToDelete.push(e)
		},
		salvaPlanejamentoInventario() {
			this.validarMarcadores()

			this.salvandoPlanejamento = true

			if (this.isSingleTrees) {
				const intensidadeAmostral =
					this.model.orsv_nr_intensidade_amostral !== null
						? this.model.orsv_nr_intensidade_amostral
						: 0 // Se for nulo, atribui zero ou outro valor padrão adequado
				const buffer = this.model.orsv_nr_buffer !== null ? this.model.orsv_nr_buffer : 0

				const ordemDeServico = {
					ordemDeServicoId: this.model.id,
					geofence: this.model.orsv_md_geofence,
					metodologiaAmostral: this.model.orsv_tx_metodologia_amostral,
					intensidadeAmostral: intensidadeAmostral,
					totalDeAmostras: this.model.orsv_nr_amostra_total,
					numeroDeReferenciaDeAmostras: this.coeficienteVariacao.amostrasReferencia,
					coeficienteDeVariacao: this.coeficienteVariacao.coeficiente,
					targetDeErro: this.coeficienteVariacao.targetErro,
					buffer: buffer,
					calculoPorCoeficienteDeVariacao: this.model.orsv_is_cv,
					bitterlich: this.model.orsv_is_bitterlich,
				}

				ordemDeServico.amostras = this.parcelas.map((amostra) => {
					let codigo
					if (amostra.codigo) {
						codigo = amostra.codigo.toString()
					} else if (amostra.COD_PARCEL) {
						codigo = amostra.COD_PARCEL.toString()
					} else if (this.codigoParcela && amostra[this.codigoParcela]) {
						codigo = amostra[this.codigoParcela].toString()
					} else {
						codigo = '' // Valor padrão se nenhuma das condições for atendida
					}
					return {
						id: uuidv4(),
						fazendaId: this.estratosFlorestais.find(
							(estrato) => estrato.id === this.model.fk_esfl_estrato_florestal,
						).fk_fzda_fazenda,
						plantioId: amostra.plantioId,
						codigo: codigo,
						coordenadaX: amostra.coordenadaX.toString(),
						coordenadaY: amostra.coordenadaY.toString(),
					}
				})
				ordemDeServico.totalDeAmostras = ordemDeServico.amostras.length
				ordemDeServicoSingleTreesPlanejar(ordemDeServico)
					.then(() => {
						this.salvandoPlanejamento = false

						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})

						this.mostrarMapaPlantio = false
						this.isEdit = !this.isEdit
						this.showForm = false
					})
					.catch(() => {
						this.salvandoPlanejamento = false

						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageText: this.$t('erroPlanejamento'),
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
						})
					})
			} else if (this.codigoTipoServico === '009') {
				savePlanejamentoInstalacaoCLR({
					ordemDeServicoId: this.model.id,
					concentradoresToCreateNovas: this.concentradoresToCreateNovas,
					concentradoresToDelete: [],
				})
					.then(() => {
						this.salvandoPlanejamento = false

						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})

						this.mostrarMapaPlantio = !this.mostrarMapaPlantio
						this.isEdit = !this.isEdit
						this.showForm = false
					})
					.catch(() => {
						this.salvandoPlanejamento = false

						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageText: this.$t('erroPlanejamento'),
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
						})
					})
			} else {
				let parcelastocreateexistentes = this.parcelas
					.filter((f) => f.existente && !f.hasChanged)
					.map((m) => {
						return {
							id: m.id,
							codigo: m.codigo,
							coordenadaX: m.coordenadaX.toString(),
							coordenadaY: m.coordenadaY.toString(),
							dataDeColeta: m.dataDeFechamento,
							plantioId: m.plantioId,
						}
					})

				let parcelastocreatenovas = this.parcelas
					.filter((f) => !f.existente)
					.map((m) => {
						return {
							id: m.id,
							codigo: String(m[this.codigoParcela] || m.codigo || this.codigoParcela || ''),
							coordenadaX: m.coordenadaX.toString(),
							coordenadaY: m.coordenadaY.toString(),

							dataDeColeta: null,
							plantioId: m.plantioId,
						}
					})

				let parcelastoupdate = this.parcelas
					.filter((f) => f.existente && f.hasChanged)
					.map((m) => {
						return {
							id: m.id,
							codigo: m.codigo,
							coordenadaX: m.coordenadaX.toString(),
							coordenadaY: m.coordenadaY.toString(),
							dataDeColeta: m.dataDeFechamento,
							plantioId: m.plantioId,
						}
					})

				var requestBody = {
					ordemdeservicoid: this.model.id,
					formatoDaParcela: this.model.orsv_tx_forma_parcela,
					medidaParcela: this.model.orsv_md_medida_parcela,
					geofence: this.model.orsv_md_geofence,
					metodologiaAmostral: this.model.orsv_tx_metodologia_amostral,
					totalDeParcelas: this.model.orsv_nr_amostra_total || this.parcelas.length,
					numeroDeReferenciaDeParcelas: this.coeficienteVariacao.amostrasReferencia,
					coeficienteDeVariacao: this.coeficienteVariacao.coeficiente,
					targetError: this.coeficienteVariacao.targetErro,
					buffer: this.model.orsv_nr_buffer,
					calculoPorCoeficienteDeVariacao: this.model.orsv_is_cv,
					intensidadeAmostral: this.model.orsv_nr_intensidade_amostral,
					parcelasNovas: parcelastocreatenovas,
					parcelasAtualizar: parcelastoupdate,
					parcelasParaCriarRelacaoComOrdemDeServico: parcelastocreateexistentes,
					parcelasParaExcluir: this.parcelasToDelete,
				}

				ordemDeServicoTradicionalPlanejar(requestBody)
					.then(() => {
						this.salvandoPlanejamento = false

						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})

						this.mostrarMapaPlantio = false
						this.isEdit = !this.isEdit
						this.showForm = false
					})
					.catch(() => {
						this.salvandoPlanejamento = false

						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageText: this.$t('erroPlanejamento'),
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
						})
					})
			}
		},
		setFazendaCustoms(value) {
			this.customsFazenda = value
		},
		btnLancaParcelas() {
			this.btnLanca = true
		},
		/**
		 * Dispara o lancamento de marcadores (parcelas/amostras) no sistema
		 */
		async lancarMarcadores() {
			this.parcelas = []
			var tentativas = 0

			while (this.totalDeParcelasEstaDiferenteDoNumeroTotalQueDeveSerGerado()) {
				await this.metodologias[this.model.orsv_tx_metodologia_amostral]()

				tentativas++
				if (tentativas === 50) {
					this.mutationShowMessage({
						messageTitle: this.$t('aviso'),
						messageText: this.$t('intensidadeIncorreta'),
						messageIcon: 'far fa-check-circle',
						messageType: 'warning',
					})

					this.$nextTick(() => {
						this.resetParcelas()
					})
					return
				}
			}

			this.validarMarcadores()
		},

		totalDeParcelasEstaDiferenteDoNumeroTotalQueDeveSerGerado() {
			return this.parcelas.length != this.model.orsv_nr_amostra_total
		},

		/**
		 * Faz a validacao dos marcadores
		 */
		validarMarcadores() {
			var tipoDeServico = this.model.tpsv_cd_codigo

			if (
				tipoDeServico === tiposDeOrdensDeServico.INVENTARIO_DE_INSTALACAO ||
				tipoDeServico === tiposDeOrdensDeServico.INVENTARIO_CONTINUO ||
				tipoDeServico === tiposDeOrdensDeServico.INVENTARIO_PRE_CORTE
			) {
				this.validarPosicionamentoDasParcelas()
			} else if (tipoDeServico === tiposDeOrdensDeServico.INSTALACAO_SINGLE_TREES) {
				this.validarPosicionamentoDasAmostras()
			}
		},

		/**
		 * Validacao de intensidade amostral por plantio
		 */
		validarIntensidadeAmostralPorPlantio() {
			// Se não houver intensidade amostral configurada, não faz validação
			if (!this.model.orsv_nr_intensidade_amostral || this.model.orsv_nr_intensidade_amostral <= 0) {
				this.mensagemDeIntensidadeAmostral = ''
				return
			}
		
			let mensagem = `<b>${this.$t('plantioComQuantidade')} ${this.marcador}s ${this.$t('intensidadeAmostral')} <u>${this.model.orsv_nr_intensidade_amostral} ${this.$t('hectareParcela')}</u>${this.$t('doEstrato')}</b><br>`
			let possuiPlantioComBaixaIntensidadeAmostral = false

			const quantidadeDeMarcadoresPorPlantio = this.contarQuantidadeDeMarcadoresEmTodosOsPlantio()

			this.getGeoJsonPtio.features.forEach((feature) => {
				const quantidadeDeMarcadores = quantidadeDeMarcadoresPorPlantio.find(
					(quantidadePorPlantio) => quantidadePorPlantio.idPlantio === feature.properties.idPlantio,
				).totalDeMarcadores
				const areaPlantio = feature.properties.Area
				const intensidadeDoPlantio = Math.round(
					areaPlantio / this.model.orsv_nr_intensidade_amostral,
				)

				if (quantidadeDeMarcadores < intensidadeDoPlantio) {
					mensagem += `${this.$t('intensidadeHaParcela')} <b>${feature.properties['Codigo Plantio']}</b> ${this.$t('tenha')} <u>${intensidadeDoPlantio} ${this.marcador}s</u> ${this.$t('eEsta')} <u>${quantidadeDeMarcadores} ${this.marcador}s</u>  <br>`
					possuiPlantioComBaixaIntensidadeAmostral = true
				}
			})

			if (possuiPlantioComBaixaIntensidadeAmostral) this.mensagemDeIntensidadeAmostral = mensagem
			else this.mensagemDeIntensidadeAmostral = ''
		},

		/**
		 * Valida as parcelas dos plantios, considerando:
		 *
		 * - Ao menos 1 parcela por plantio
		 * - Intensidade amostrasl
		 */
		validarPosicionamentoDasParcelas() {
			// Faz a contagem de parcelas por plantio
			var plantiosEParcelas = this.contarQuantidadeDeMarcadoresEmTodosOsPlantio()

			// Retorna os plantios que estao sem parcelas
			var plantiosSemParcelas = plantiosEParcelas.filter(
				(quantidadeDeMarcador) => quantidadeDeMarcador.totalDeMarcadores <= 0,
			)

			// Ids dos plantios sem parcela
			var idsDosPlantiosSemParcela = plantiosSemParcelas.map(
				(plantioSemParcelas) => plantioSemParcelas.idPlantio,
			)

			// Pinta a borda dos poligonos dos plantios sem parcelas
			this.getGeoJsonPtio.features.forEach((feature) => {
				if (idsDosPlantiosSemParcela.includes(feature.properties.idPlantio))
					feature.properties.plantioSemMarcador = true
				else feature.properties.plantioSemMarcador = false
			})

			// Caso o plantio nao tenha parcelas
			if (plantiosSemParcelas.length > 0) {
				var mensagem = `${this.$t('plantiosSemParcela')} ${this.marcador}s: </br>`
				plantiosSemParcelas.forEach(
					(plantiosSemParcelas) =>
						(mensagem += `• ${this.$t('plantio')}: ${plantiosSemParcelas.codigoPlantio} </br>`),
				)

				this.mutationShowMessage({
					messageTitle: this.$t('erro'),
					messageText: `${mensagem}`,
					messageIcon: 'far fa-check-circle',
					messageType: 'error',
				})

				throw new Error()
			}

			this.$refs.planejamentoOrdemServico.$forceUpdate()
		},

		/**
		 * Valida as amostras dos plantios, considerando:
		 *
		 * - Ao menos 2 amostras por plantio
		 */
		validarPosicionamentoDasAmostras() {
			// Faz a contagem de amostras por plantio
			var plantiosEParcelas = this.contarQuantidadeDeMarcadoresEmTodosOsPlantio()

			// Retorna os plantios que estao com menos de 1 amostras
			var plantiosComPoucasAmostras = plantiosEParcelas.filter(
				(quantidadeDeMarcador) => quantidadeDeMarcador.totalDeMarcadores < 1,
			)

			// Ids dos plantios sem amostras
			var idsDosPlantiosSemParcela = plantiosComPoucasAmostras.map(
				(plantioSemParcelas) => plantioSemParcelas.idPlantio,
			)

			// Pinta a borda dos poligonos dos plantios sem amostras
			this.getGeoJsonPtio.features.forEach((feature) => {
				if (idsDosPlantiosSemParcela.includes(feature.properties.idPlantio))
					feature.properties.plantioSemMarcador = true
				else feature.properties.plantioSemMarcador = false
			})

			// Caso o plantio nao tenha amostra
			if (plantiosComPoucasAmostras.length > 0) {
				var mensagem = `${this.$t('plantioSemAmostra')} ${this.marcador}s: </br>`
				plantiosComPoucasAmostras.forEach(
					(plantioComPoucasAmostras) =>
						(mensagem += `• ${this.$t('plantio')}: ${plantioComPoucasAmostras.codigoPlantio} </br>`),
				)

				this.mutationShowMessage({
					messageTitle: this.$t('erro'),
					messageText: `${mensagem}`,
					messageIcon: 'far fa-check-circle',
					messageType: 'error',
				})

				throw new Error()
			}

			this.$refs.planejamentoOrdemServico.$forceUpdate()
		},

		/**
		 * Faz a validacao de marcadores de um unico plantio
		 * @param {plantioId} plantioId
		 */
		// validarMarcadorNoPlantio(plantioId){
		//   const quantidadeDeMarcadores = this.contarQuantidadeDeMarcadoresNoPlantio(plantioId);

		//   var tipoDeServico = this.model.tpsv_cd_codigo;

		//   if (tipoDeServico === tiposDeOrdensDeServico.INVENTARIO_DE_INSTALACAO ||
		//       tipoDeServico === tiposDeOrdensDeServico.INVENTARIO_CONTINUO ||
		//       tipoDeServico === tiposDeOrdensDeServico.INVENTARIO_PRE_CORTE) {
		//       this.getGeoJsonPtio.features.forEach(feature => {
		//         if (quantidadeDeMarcadores === 0)
		//           feature.properties.plantioSemMarcador = true;
		//         else
		//           feature.properties.plantioSemMarcador = false;
		//       });
		//   }
		//   else if (tipoDeServico === tiposDeOrdensDeServico.INSTALACAO_SINGLE_TREES) {
		//       console.log("teste")
		//   }

		//   this.$refs.planejamentoOrdemServico.$forceUpdate();
		// },

		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * criado no banco de dados
		 */
		createOrdemDeServicoToPost() {
			this.setFkExos()

			const dataToPost = {
				id: this.model.id,
				orsv_extrs: '',
				fk_tpsv_tipo_servico: this.model.fk_tpsv_tipo_servico,
				executoresIds: this.executoresSelecionados,
				fk_esfl_estrato_florestal: this.model.fk_esfl_estrato_florestal,
				orsv_cd_tipo_servico: this.codigoTipoServico,
				tpsv_cd_codigo: this.tiposDeServicoComputados
					.find((f) => f.value === this.model.fk_tpsv_tipo_servico)
					.label.split('-')[0]
					.trim(),
				orsv_ds_descricao: this.model.orsv_ds_descricao,
				orsv_dt_data_inicial: new Date(this.model.orsv_dt_data_inicial).toLocaleDateString(),
				orsv_dt_prazo_final: new Date(this.model.orsv_dt_prazo_final).toLocaleDateString(),
				tpsv_ds_descricao: this.tiposDeServicoComputados
					.find((f) => f.value === this.model.fk_tpsv_tipo_servico)
					.label.split('-')[1]
					.trim(),
				orsv_tx_forma_parcela: this.model.orsv_tx_forma_parcela,
				orsv_is_cv: this.model.orsv_is_cv || null,
				orsv_is_bitterlich: this.model.orsv_is_bitterlich || null,
				orsv_nr_buffer: this.model.orsv_nr_buffer || 0,
				orsv_tx_metodologia_amostral: this.model.orsv_tx_metodologia_amostral,
				orsv_md_geofence:
					this.model.orsv_md_geofence !== null ? this.model.orsv_md_geofence.toString() : null,
				orsv_md_medida_parcela:
					this.model.orsv_md_medida_parcela !== null
						? this.model.orsv_md_medida_parcela.toString()
						: null,
				orsv_nr_intensidade_amostral:
					this.model.orsv_nr_intensidade_amostral !== ''
						? this.model.orsv_nr_intensidade_amostral
						: null,
				orsv_nr_amostra_total: this.model.orsv_nr_amostra_total || null,
				inventarioReferencia: this.model.inventarioReferencia,
				verificarConsistencia: this.model.verificarConsistencia,
				prePreencherEstruturaInventarioAnterior: this.model.prePreencherEstruturaInventarioAnterior,
				orsv_dt_hora_inicio_medicao: this.model.orsv_dt_hora_inicio_medicao || null,
				orsv_tx_frequencia_coleta: this.model.orsv_tx_frequencia_coleta
					? this.converterFrequenciaColetaParaEnum(this.model.orsv_tx_frequencia_coleta)
					: null,
				orsv_tx_periodo_disponivel: this.model.orsv_tx_periodo_disponivel
					? this.converterPeriodoDisponivelParaEnum(this.model.orsv_tx_periodo_disponivel)
					: null,
			}

			return dataToPost
		},
		/**
		 * Cria nova Ordem de Servico no banco de dados
		 */
		create() {
			const ordemDeServico = this.createOrdemDeServicoToPost()

			createOrdemDeServico(ordemDeServico).then((response) => {
				const { result: ordemDeServico, message } = response.data
				this.disableSaveButton = false

				if (message === '' || message == null) {
					this.formataOrdemDeServicoParaTabela(ordemDeServico)
					ordemDeServico.orsv_md_progresso = 0
					this.modelList.unshift(ordemDeServico)
					this.model = JSON.parse(JSON.stringify(ordemDeServico))

					this.showForm = true
					this.emptyValue = ''
					this.isCreate = true

					if (['001', '002', '003', '007', '019'].includes(this.model.tpsv_cd_codigo)) {
						this.getPlanejamentoOrdemServico[this.model.tpsv_cd_codigo](
							this.model.id,
							this.model.fk_esfl_estrato_florestal,
						)
					}

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageText: this.$t('osCriada'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
					if (this.codigoTipoServico === '005') {
						this.planejamentoCubagem = true
						this.showForm = false
						this.$router.push({
							path: '/ordemdeservico/planejamentocubagem',
							query: {
								ordemServicoId: ordemDeServico.id,
								estratoFlorestalId: ordemDeServico.fk_esfl_estrato_florestal,
								executoresIds: this.model.executoresIds,
								planejamento: JSON.stringify({
									diametroReferencia: this.model.orsv_enum_tipo_diametro_referencia || 'DAP',
									metodologiaCubagem:
										this.model.orsv_enum_metodologia_cubagem || 'DISTANCIAS_FIXAS',
									distanciaMedicoes:
										this.model.orsv_enum_cubagem_distancias_fixas_distancia || 'UM_METRO',
								}),
							},
						})
					} else if (this.codigoTipoServico !== '008' && this.codigoTipoServico !== '010') {
						this.mostrarMapaPlantio = !this.mostrarMapaPlantio
					}
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
						messageText: message,
					})
				}
			})
		},

		/**
		 * Atualiza especie no banco de dados
		 */
		update() {
			this.setFkExos()
			const ordemDeServico = this.createOrdemDeServicoToPost()

			updateOrdemDeServico(ordemDeServico).then((response) => {
				const { message, isError } = response.data
				this.disableSaveButton = false

				if (!isError) {
					//  this.formataOrdemDeServicoParaTabela(ordemDeServico)

					//   const indexOrdemDeServico = this.modelList
					//     .map((m) => m.id)
					//     .indexOf(this.model.id)
					//   this.$set(this.modelList, indexOrdemDeServico, ordemDeServico)
					this.refreshTabela()
					this.showForm = false

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
						messageText: message,
					})
				}
			})
		},

		refreshTabela(pageNumber, pageSize, filteringWord) {
			this.tableConfiguration.statusTable = this.$t('loading')
			getAllOrdensDeServicos(pageNumber, pageSize, filteringWord).then((response) => {
				const { result: ordensDeServicos } = response.data
				if (!ordensDeServicos || ordensDeServicos.length === 0) {
					return
				}

				ordensDeServicos.forEach((ordemDeServico) => {
					this.formataOrdemDeServicoParaTabela(ordemDeServico)

					switch (ordemDeServico.tpsv_cd_codigo) {
						case tiposDeOrdensDeServico.INVENTARIO_DE_INSTALACAO:
						case tiposDeOrdensDeServico.INVENTARIO_CONTINUO:
						case tiposDeOrdensDeServico.INVENTARIO_PRE_CORTE:
						case tiposDeOrdensDeServico.INVENTARIO_DE_QUALIDADE:
							ordemDeServico.orsv_md_progresso = parseFloat(
								ordemDeServico.porcentagemParcelasColetadas.toFixed(2),
							)
							break
						case tiposDeOrdensDeServico.COLETA_DE_CUBAGEM:
							ordemDeServico.orsv_md_progresso = parseFloat(
								ordemDeServico.porcentagemArvoresCubadas.toFixed(2),
							)
							break
						case tiposDeOrdensDeServico.INSTALACAO_SINGLE_TREES:
							ordemDeServico.orsv_md_progresso = parseFloat(
								ordemDeServico.porcentagemAmostrasInstaladasSingleTrees.toFixed(2),
							)
							break
						case tiposDeOrdensDeServico.COLETA_SINGLE_TREES:
							ordemDeServico.orsv_md_progresso = parseFloat(
								ordemDeServico.porcentagemAmostrasColetadasSingleTrees.toFixed(2),
							)
							break
						case tiposDeOrdensDeServico.INSTALACAO_DE_DENDROMETROS:
							ordemDeServico.orsv_md_progresso = parseFloat(
								ordemDeServico.porcentagemConcentradoresInstaladosHighPrecisionLongRange.toFixed(2),
							)
							break
						case tiposDeOrdensDeServico.COLETA_HIGH_PRECISION:
							ordemDeServico.orsv_md_progresso = parseFloat(
								ordemDeServico.porcentagemConcentradoresColetadosHighPrecisionLongRange.toFixed(2),
							)
							break

						case tiposDeOrdensDeServico.INVENTARIO_DE_PILHA:
							ordemDeServico.orsv_md_progresso = parseFloat(
								ordemDeServico.porcentagemOrdemDeServicoDePilha.toFixed(2),
							)
							break

						default:
							console.log('Tipo de Ordem de serviço não identificada')
					}
				})

				this.modelList = ordensDeServicos

				this.tableConfiguration.statusTable = this.$t('noRecordFound')
			})
		},

		/**
		 * Exclui fazenda no banco de dados
		 */
		deleteModels(email) {
			const emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				const existeRegistroComDependencia = this.modelList.filter(
					(ordemDeServico) =>
						this.modelsIdWithCheckedToDelete.includes(ordemDeServico.id) &&
						ordemDeServico.possuiDependenciaDeRegistro,
				)
				if (existeRegistroComDependencia.length == 0) {
					const confirmResult = confirm(this.$t('confirmaExclusao'))

					if (confirmResult) {
						deleteOrdemDeServicoByIdList(this.modelsIdWithCheckedToDelete).then(() => {
							this.modelsIdWithCheckedToDelete.forEach((f) => {
								const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
								this.modelList.splice(indexToRemove, 1)
							})

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
							this.showDeleteConfirmationPopup = false
						})
					}
				} else {
					var medicoesOrganizadas = existeRegistroComDependencia
						.map(
							(ordemDeServico) =>
								`• OS-${ordemDeServico.orsv_cd_codigo} -  ${ordemDeServico.orsv_ds_descricao}`,
						)
						.join('<br/>')
					var message = `<b>${this.$t('registroAtreladoAOS')}:</b> <br/><br/> ${medicoesOrganizadas}`
					this.mutationShowMessage({
						messageTitle: this.$t('cuidado'),
						messageIcon: 'fas fa-exclamation-circle',
						messageType: 'warning',
						messageText: message,
					})
				}
			} else {
				// Se o email não for o mesmo do usuario logado, exibe mensagem de erro
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		exportarOutliers() {
			const medicoesParaExportar = this.medicoesNormalizadas.map((medicao) => {
				return [
					medicao.talhao,
					medicao.plantio,
					medicao.parcela,
					medicao.areaParcela,
					this.converterParaPadraoDeDataCorreto(medicao.dataPlantio),
					this.converterParaPadraoDeDataCorreto(medicao.dataColeta),
					medicao.linha,
					medicao.arvore,
					medicao.fuste,
					medicao.cap,
					medicao.dap,
					medicao.ht,
					medicao.categoriaDaArvore,
					medicao.inclinacao,
					medicao.coordenadaX,
					medicao.coordenadaY,
					medicao.observacao,
					medicao.nivelRisco,
					medicao.insights.find(
						(insight) =>
							insight.message.includes(outliersMessage.DAP_ABAIXO_PLANTIO) ||
							insight.message.includes(outliersMessage.DAP_ACIMA_PLANTIO),
					)?.message,
					medicao.insights.find(
						(insight) =>
							insight.message.includes(outliersMessage.HT_ABAIXO_PLANTIO) ||
							insight.message.includes(outliersMessage.HT_ACIMA_PLANTIO),
					)?.message,
					medicao.insights.find(
						(insight) =>
							insight.message.includes(outliersMessage.DAP_HT_ACIMA_PLANTIO) ||
							insight.message.includes(outliersMessage.DAP_HT_ACIMA_PLANTIO),
					)?.message,
					medicao.insights.find(
						(insight) =>
							insight.message.includes(outliersMessage.DAP_ABAIXO_PLANTIO_IDADE) ||
							insight.message.includes(outliersMessage.DAP_ACIMA_PLANTIO_IDADE),
					)?.message,
					medicao.insights.find(
						(insight) =>
							insight.message.includes(outliersMessage.HT_ABAIXO_PLANTIO_IDADE) ||
							insight.message.includes(outliersMessage.HT_ACIMA_PLANTIO_IDADE),
					)?.message,
					medicao.insights.find(
						(insight) =>
							insight.message.includes(outliersMessage.DAP_HT_ABAIXO_PLANTIO_IDADE) ||
							insight.message.includes(outliersMessage.DAP_HT_ACIMA_PLANTIO_IDADE),
					)?.message,
					medicao.insights.find(
						(insight) =>
							insight.message.includes(outliersMessage.DAP_ABAIXO_ESTRATO) ||
							insight.message.includes(outliersMessage.DAP_ACIMA_ESTRATO),
					)?.message,
					medicao.insights.find(
						(insight) =>
							insight.message.includes(outliersMessage.HT_ABAIXO_ESTRATO) ||
							insight.message.includes(outliersMessage.HT_ACIMA_ESTRATO),
					)?.message,
					medicao.insights.find(
						(insight) =>
							insight.message.includes(outliersMessage.DAP_HT_ABAIXO_ESTRATO) ||
							insight.message.includes(outliersMessage.DAP_HT_ACIMA_ESTRATO),
					)?.message,
				]
			})

			const colunas = [
				'talhao',
				'plantio',
				'parcela',
				'area_da_parcela',
				'data_do_plantio',
				'data_de_coleta',
				'linha',
				'arvore',
				'fuste',
				'cap',
				'dap',
				'ht',
				'categoria_da_arvore',
				'inclinacao',
				'coordenada_x',
				'coordenada_y',
				'observacao',
				'nivel_de_risco',
				'outlier_1',
				'outlier_2',
				'outlier_3',
				'outlier_4',
				'outlier_5',
				'outlier_6',
				'outlier_7',
				'outlier_8',
				'outlier_9',
				'inconsistencia_1',
				'inconsistencia_2',
				'inconsistencia_3',
				'inconsistencia_4',
			]
			const csv = [colunas, ...medicoesParaExportar]
				.map((registro) => registro.join(';'))
				.join('\r\n')

			download(csv, 'Análise de Outliers.csv', 'text/csv')
		},

		/**
		 *  Converte data para o padrao correto do sistema: dd/MM/yyyy
		 */
		converterParaPadraoDeDataCorreto(dataFormatoOriginal) {
			if (this.dataEstaNoPadraoISO(dataFormatoOriginal)) {
				var dataFormatoCorreto = dataFormatoOriginal.split('T')[0]
				var dataSeparada = dataFormatoCorreto.split('-')
				dataFormatoCorreto = `${dataSeparada[2]}/${dataSeparada[1]}/${dataSeparada[0]}`
				return dataFormatoCorreto
			}
			return dataFormatoOriginal
		},

		/**
		 * Verifica se data esta no padrao ISO 8601
		 */
		dataEstaNoPadraoISO(data) {
			const EXPRESSAO_PARA_ISO_8601 = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/
			return EXPRESSAO_PARA_ISO_8601.test(data)
		},

		/**
		 * Formata campos do model para exibir na tabela de crud
		 */
		formataOrdemDeServicoParaTabela(ordemDeServico) {
			ordemDeServico.isCheckedToDelete = false
			ordemDeServico.isContinuo = this.estratosFlorestais.find(
				(estrato) => estrato.id === ordemDeServico.fk_esfl_estrato_florestal,
			)['Continuo?']

			let tpsv = this.tiposDeServicoComputados.find((tipoDeServico) =>
				tipoDeServico.value.startsWith(ordemDeServico.fk_tpsv_tipo_servico),
			)

			ordemDeServico.tipoDeServico = tpsv ? tpsv.label : this.$t('notInformed')

			ordemDeServico.dataInicial = ordemDeServico.orsv_dt_data_inicial
				? new Date(ordemDeServico.orsv_dt_data_inicial).toLocaleDateString()
				: ''

			ordemDeServico.prazoFinal = ordemDeServico.orsv_dt_prazo_final
				? new Date(ordemDeServico.orsv_dt_prazo_final).toLocaleDateString()
				: ''

			ordemDeServico.finalizacaoDaOs = ordemDeServico.orsv_dt_data_final
				? new Date(ordemDeServico.orsv_dt_data_final).toLocaleDateString()
				: ''

			ordemDeServico.amostras = this.formatarAmostras(ordemDeServico)
		},

		formatarAmostras(ordemDeServico) {
			const tiposInventarioTradicional = [
				tiposDeOrdensDeServico.INVENTARIO_DE_INSTALACAO,
				tiposDeOrdensDeServico.INVENTARIO_CONTINUO,
				tiposDeOrdensDeServico.INVENTARIO_PRE_CORTE,
				tiposDeOrdensDeServico.INVENTARIO_DE_QUALIDADE,
			]

			if (tiposInventarioTradicional.includes(ordemDeServico.tpsv_cd_codigo)) {
				const coletadas = ordemDeServico.quantidadeParcelasColetadas ?? 0
				const total = ordemDeServico.totalParcelas ?? 0
				return `${coletadas}/${total}`
			}

			if (ordemDeServico.tpsv_cd_codigo === tiposDeOrdensDeServico.COLETA_DE_CUBAGEM) {
				const cubadas = ordemDeServico.quantidadeArvoresCubadas ?? 0
				const total = ordemDeServico.totalArvoresCubagem ?? 0
				return `${cubadas}/${total}`
			}

			if (
				ordemDeServico.tpsv_cd_codigo === tiposDeOrdensDeServico.INSTALACAO_SINGLE_TREES ||
				ordemDeServico.tpsv_cd_codigo === tiposDeOrdensDeServico.COLETA_SINGLE_TREES
			) {
				const instaladas = ordemDeServico.quantidadeAmostrasInstaladasSingleTrees ?? 0
				const total = ordemDeServico.totalAmostrasSingleTrees ?? 0
				return `${instaladas}/${total}`
			}

			return '-'
		},

		/**
		 * Remove os executores que não fazem mais parte da ordem de servico
		 * Adiciona os executores que ainda não estão relacionados a ordem de servico
		 */
		setFkExos() {
			_.remove(this.model.fk_exos, (exos) => {
				return !this.executoresSelecionados.includes(exos.fk_extr_executor)
			})

			if (!this.model.fk_exos) this.model.fk_exos = []

			this.executoresSelecionados.forEach((executor) => {
				const idExecutor = this.model.fk_exos.find((exos) => exos.fk_extr_executor === executor)

				if (!idExecutor) {
					this.model.fk_exos.push({
						id: uuidv4(),
						fk_extr_executor: executor,
						fk_orsv_ordem_servico: this.model.id,
					})
				}
			})
		},

		confirmClick() {
			if (!this.isInventarioDePilha) {
				this.saveClick()
			} else {
				this.mostrarInventarioDePilha = true
			}
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			this.disableSaveButton = true
			if (this.isEdit) {
				this.update()
			} else {
				this.create()
			}
		},

		showResumoModelForm(model) {
			this.model = Object.assign({}, model)
			this.executoresSelecionados = model.executoresIds //this.model.fk_exos.map( (m) => m.fk_extr_executor );

			this.isResumo = !this.isResumo

			this.titleForm = this.$t('summary')
		},
		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(model) {
			// Desabilita watchers durante atribuição inicial do model
			this.atualizandoDropdownOperacao = true

			this.model = Object.assign({}, model)

			// Captura a versão do dendrômetro como ela estava ao entrar em edição.
			// Usado pelos computeds camposOperacaoDesabilitados/camposDataHoraDesabilitados
			// para liberar os campos quando a OS foi pausada antes de finalizar a etapa de Operação.
			this.versaoDendrometroOriginalAoEditar = this.model.orsv_tx_versao_dendrometro || ''

			// Converte os valores do enum do backend para os valores dos dropdowns
			if (this.model.orsv_tx_frequencia_coleta) {
				this.model.orsv_tx_frequencia_coleta = this.converterEnumParaFrequenciaColeta(
					this.model.orsv_tx_frequencia_coleta
				)
			}
			if (this.model.orsv_tx_periodo_disponivel) {
				this.model.orsv_tx_periodo_disponivel = this.converterEnumParaPeriodoDisponivel(
					this.model.orsv_tx_periodo_disponivel
				)
			}


			// Extrai a hora do campo de data se existir (formato ISO: YYYY-MM-DDTHH:MM:SS)
			if (this.model.orsv_dt_hora_inicio_medicao && this.model.orsv_dt_hora_inicio_medicao.includes('T')) {
				const partes = this.model.orsv_dt_hora_inicio_medicao.split('T')
				if (partes.length > 1 && partes[1]) {
					// Extrai apenas HH:MM (ignora os segundos)
					this.horaInicio = partes[1].substring(0, 5)
				}
			}
			this.executoresSelecionados = [...new Set(model.executoresIds)] //this.model.fk_exos.map( (m) => m.fk_extr_executor );

			this.titleForm = `${this.$t('edit')} ${this.$t('serviceOrder')}`
			this.isEdit = true
			
			// Reabilita os watchers após carregar o model
			this.$nextTick(() => {
				this.atualizandoDropdownOperacao = false
				console.log('🔵 Watchers reabilitados após showEditModelForm')
			})
			
			this.changeFormAndCloseAllActions()
			if (['001', '002', '003', '007', '019'].includes(this.model.tpsv_cd_codigo)) {
				this.getPlanejamentoOrdemServico[this.model.tpsv_cd_codigo](
					this.model.id,
					this.model.fk_esfl_estrato_florestal,
				)
			}
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()
			this.titleForm = `${this.$t('create')} ${this.$t('serviceOrder')}`
			this.model.orsv_dt_data_inicial = new Date().toISOString()
			this.model.orsv_dt_prazo_final = new Date(
				new Date().setDate(new Date().getDate() + 7),
			).toISOString()
			this.model.orsv_tx_metodologia_amostral = 'Sistematico'
			this.model.id = uuidv4()
			this.executoresSelecionados = []
			this.model.inventarioReferencia = undefined

			this.isEdit = false
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActionsResumo() {
			this.isResumo = !this.isResumos
		},

		changeFormAndCloseAllActionsCRUD() {
			this.showForm = !this.showForm
			this.resetState()
		},
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
			this.mostrarInventarioDePilha = false

			this.closeOrdemServico()
		},
		closeOrdemServico() {
			this.mostrarMapaPlantio = false
			this.parcelas.length = 0
		},
		salvouPlanejamentoDePilha(ordemDeServico) {
			this.formataOrdemDeServicoParaTabela(ordemDeServico)
			ordemDeServico.orsv_md_progresso = 0
			this.modelList.unshift(ordemDeServico)
		},
		editouPlanejamentoDePilha(ordemDeServico) {
			this.formataOrdemDeServicoParaTabela(ordemDeServico)
			const indexOrdemDeServico = this.modelList.map((m) => m.id).indexOf(ordemDeServico.id)
			ordemDeServico.orsv_md_progresso = 0 //TODO: Verificar como vai calcular o progresso de pilha
			this.$set(this.modelList, indexOrdemDeServico, ordemDeServico)
		},
		fecharModal() {
			this.showForm = false
			this.ordemDeServicoDePilha = undefined
		},

		/**
		 * Navega do Planejamento para a etapa de Operação
		 */
		avancarParaOperacao() {
			if (!this.isGeoJsonPlantioEmpty) {
				this.mostrarMapaPlantio = false
				this.mostrarOperacao = true
			} else {
				this.mutationShowMessage({
					messageIcon: 'fas fa-exclamation-triangle',
					messageType: 'error',
					messageText: 'É necessário concluir o planejamento antes de avançar',
				})
			}
		},

		/**
		 * Decide qual ação executar ao clicar no botão de salvar/avançar do planejamento
		 */
		handleSalvarPlanejamento() {
			console.log('🔵 handleSalvarPlanejamento chamado')
			console.log('🔵 Tipo de OS:', this.model.tpsv_cd_codigo)
			console.log('🔵 isSingleTrees:', this.isSingleTrees)
			console.log('🔵 isOrdemServicoInstalacao (007 + SingleTrees):', this.isOrdemServicoInstalacao)

			if (this.isOrdemServicoInstalacao) {
				console.log('✅ É Instalação Single Trees (007) - Executando salvarPlanejamentoEAvancarParaOperacao')
				this.salvarPlanejamentoEAvancarParaOperacao()
			} else {
				console.log('✅ Não é Instalação Single Trees - Executando salvaPlanejamentoInventario')
				this.salvaPlanejamentoInventario()
			}
		},

		/**
		 * Salva o planejamento e avança para a etapa de Operação
		 * (apenas para OS de Instalação Single Trees - código 007 + isSingleTrees)
		 */
		async salvarPlanejamentoEAvancarParaOperacao() {
			console.log('🟢 salvarPlanejamentoEAvancarParaOperacao iniciado')
			console.log('🟢 Tipo de OS:', this.model.tpsv_cd_codigo)
			console.log('🟢 isSingleTrees:', this.isSingleTrees)
			console.log('🟢 Número de parcelas:', this.parcelas.length)

			this.validarMarcadores()

			this.salvandoPlanejamento = true

			if (this.isSingleTrees) {
				console.log('🟢 Fluxo: Single Trees')
				const intensidadeAmostral =
					this.model.orsv_nr_intensidade_amostral !== null
						? this.model.orsv_nr_intensidade_amostral
						: 0
				const buffer = this.model.orsv_nr_buffer !== null ? this.model.orsv_nr_buffer : 0

				const ordemDeServico = {
					ordemDeServicoId: this.model.id,
					geofence: this.model.orsv_md_geofence,
					metodologiaAmostral: this.model.orsv_tx_metodologia_amostral,
					intensidadeAmostral: intensidadeAmostral,
					totalDeAmostras: this.model.orsv_nr_amostra_total,
					numeroDeReferenciaDeAmostras: this.coeficienteVariacao.amostrasReferencia,
					coeficienteDeVariacao: this.coeficienteVariacao.coeficiente,
					targetDeErro: this.coeficienteVariacao.targetErro,
					buffer: buffer,
					calculoPorCoeficienteDeVariacao: this.model.orsv_is_cv,
					bitterlich: this.model.orsv_is_bitterlich,
				}

				ordemDeServico.amostras = this.parcelas.map((amostra) => {
					let codigo
					if (amostra.codigo) {
						codigo = amostra.codigo.toString()
					} else if (amostra.COD_PARCEL) {
						codigo = amostra.COD_PARCEL.toString()
					} else if (this.codigoParcela && amostra[this.codigoParcela]) {
						codigo = amostra[this.codigoParcela].toString()
					} else {
						codigo = ''
					}
					return {
						id: uuidv4(),
						fazendaId: this.estratosFlorestais.find(
							(estrato) => estrato.id === this.model.fk_esfl_estrato_florestal,
						).fk_fzda_fazenda,
						plantioId: amostra.plantioId,
						codigo: codigo,
						coordenadaX: amostra.coordenadaX.toString(),
						coordenadaY: amostra.coordenadaY.toString(),
					}
				})
				ordemDeServico.totalDeAmostras = ordemDeServico.amostras.length

				try {
					console.log('🟢 Chamando API: ordemDeServicoSingleTreesPlanejar')
					await ordemDeServicoSingleTreesPlanejar(ordemDeServico)
					console.log('✅ API Single Trees retornou sucesso!')
					this.salvandoPlanejamento = false
					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
					// Avança para a etapa de Operação
					console.log('🟢 Avançando para etapa de Operação...')
					this.mostrarMapaPlantio = false
					this.mostrarOperacao = true
					console.log('✅ mostrarOperacao:', this.mostrarOperacao)
				} catch (error) {
					console.error('❌ Erro ao salvar Single Trees:', error)
					this.salvandoPlanejamento = false
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageText: this.$t('erroPlanejamento'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			} else {
				console.log('🟢 Fluxo: Tradicional')
				let parcelastocreateexistentes = this.parcelas
					.filter((f) => f.existente && !f.hasChanged)
					.map((m) => {
						return {
							id: m.id,
							codigo: m.codigo,
							coordenadaX: m.coordenadaX.toString(),
							coordenadaY: m.coordenadaY.toString(),
							dataDeColeta: m.dataDeFechamento,
							plantioId: m.plantioId,
						}
					})

				let parcelastocreatenovas = this.parcelas
					.filter((f) => !f.existente)
					.map((m) => {
						return {
							id: m.id,
							codigo: String(m[this.codigoParcela] || m.codigo || this.codigoParcela || ''),
							coordenadaX: m.coordenadaX.toString(),
							coordenadaY: m.coordenadaY.toString(),
							dataDeColeta: null,
							plantioId: m.plantioId,
						}
					})

				let parcelastoupdate = this.parcelas
					.filter((f) => f.existente && f.hasChanged)
					.map((m) => {
						return {
							id: m.id,
							codigo: m.codigo,
							coordenadaX: m.coordenadaX.toString(),
							coordenadaY: m.coordenadaY.toString(),
							dataDeColeta: m.dataDeFechamento,
							plantioId: m.plantioId,
						}
					})

				var requestBody = {
					ordemdeservicoid: this.model.id,
					formatoDaParcela: this.model.orsv_tx_forma_parcela,
					medidaParcela: this.model.orsv_md_medida_parcela,
					geofence: this.model.orsv_md_geofence,
					metodologiaAmostral: this.model.orsv_tx_metodologia_amostral,
					totalDeParcelas: this.model.orsv_nr_amostra_total || this.parcelas.length,
					numeroDeReferenciaDeParcelas: this.coeficienteVariacao.amostrasReferencia,
					coeficienteDeVariacao: this.coeficienteVariacao.coeficiente,
					targetError: this.coeficienteVariacao.targetErro,
					buffer: this.model.orsv_nr_buffer,
					calculoPorCoeficienteDeVariacao: this.model.orsv_is_cv,
					intensidadeAmostral: this.model.orsv_nr_intensidade_amostral,
					parcelasNovas: parcelastocreatenovas,
					parcelasAtualizar: parcelastoupdate,
					parcelasParaCriarRelacaoComOrdemDeServico: parcelastocreateexistentes,
					parcelasParaExcluir: this.parcelasToDelete,
				}

				try {
					console.log('🟢 Chamando API: ordemDeServicoTradicionalPlanejar')
					console.log('🟢 RequestBody:', requestBody)
					await ordemDeServicoTradicionalPlanejar(requestBody)
					console.log('✅ API Tradicional retornou sucesso!')
					this.salvandoPlanejamento = false
					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
					// Avança para a etapa de Operação
					console.log('🟢 Avançando para etapa de Operação...')
					this.mostrarMapaPlantio = false
					this.mostrarOperacao = true
					console.log('✅ mostrarOperacao:', this.mostrarOperacao)
				} catch (error) {
					console.error('❌ Erro ao salvar Tradicional:', error)
					this.salvandoPlanejamento = false
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageText: this.$t('erroPlanejamento'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			}
		},

		/**
		 * Volta da etapa de Operação para o Planejamento
		 * Para OS tipo 008, fecha o componente ao invés de ir para planejamento (pois não tem planejamento)
		 */
		voltarParaPlanejamento() {
			this.mostrarOperacao = false

			// Em edição, descarta a escolha do radio e volta para o formulário principal
			// (não persiste a versão se o usuário cancelou)
			if (this.isEdit) {
				this.model.orsv_tx_versao_dendrometro = this.versaoDendrometroOriginalAoEditar
				this.showForm = true
				return
			}

			// Se for OS tipo 008, fecha o componente completamente
			if (this.model.tpsv_cd_codigo === '008') {
				this.changeFormAndCloseAllActionsCRUD()
			} else {
				// Para outros tipos, volta para o planejamento normalmente
				this.mostrarMapaPlantio = true
			}
		},

		/**
		 * Finaliza a etapa de Operação e salva a OS
		 */
		finalizarOperacao() {
			if (this.model.orsv_tx_versao_dendrometro !== 'DLR 1.5') {
				const osId = this.model.id
				const versaoEscolhida = this.model.orsv_tx_versao_dendrometro
				updateOrdemDeServico({
					id: osId,
					orsv_tx_versao_dendrometro: versaoEscolhida,
					executoresIds: this.model.executoresIds || [],
				})
					.then(() => {
						this.atualizaVersaoDendrometroNaLista(osId, versaoEscolhida)
						this.mostrarOperacao = false
						this.mostrarMapaPlantio = false
						this.mutationShowMessage({
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
							messageText: 'Configurações de operação salvas com sucesso!',
						})
						this.limparCamposOperacao()
						this.showForm = false
						this.resetState()
						this.refreshTabela()
					})
					.catch((error) => {
						this.mutationShowMessage({
							messageIcon: 'fas fa-exclamation-circle',
							messageType: 'error',
							messageText: 'Erro ao salvar configurações de operação. Tente novamente.',
						})
						console.error('Erro ao salvar versão do dendrômetro:', error)
					})
				return
			}

			if (this.camposOperacaoValidos) {
				// Combina data e hora
				if (this.horaInicio && this.model.orsv_dt_hora_inicio_medicao) {
					// Verifica se a data já contém o formato ISO ou é uma data simples
					let date = this.model.orsv_dt_hora_inicio_medicao

					// Se for uma data ISO, extrai apenas a parte da data
					if (date.includes('T')) {
						date = date.split('T')[0]
					}

					// Se for uma data no formato DD/MM/YYYY, converte para YYYY-MM-DD
					if (date.includes('/')) {
						const [day, month, year] = date.split('/')
						date = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
					}

					// Combina data e hora no formato ISO
					this.model.orsv_dt_hora_inicio_medicao = `${date}T${this.horaInicio}:00`
				}

				// Salva os dados de operação
				this.salvarDadosOperacao()
			}
		},

		/**
		 * Converte o valor da frequência de coleta do dropdown para o enum do backend
		 */
		converterFrequenciaColetaParaEnum(valor) {
			const mapeamento = {
				'Diária': 'DIARIA',
				'A cada 2 dias': 'A_CADA_DOIS_DIAS',
				'A cada 3 dias': 'A_CADA_TRES_DIAS'
			}
			return mapeamento[valor] || valor
		},

		/**
		 * Converte o valor do período disponível do dropdown para o enum do backend
		 */
		converterPeriodoDisponivelParaEnum(valor) {
			const mapeamento = {
				'Mensal': 'MENSAL',
				'Bimestral': 'BIMESTRAL',
				'Trimestral': 'TRIMESTRAL'
			}
			return mapeamento[valor] || valor
		},

		/**
		 * Converte o valor do enum do backend para o valor do dropdown de frequência
		 */
		converterEnumParaFrequenciaColeta(valor) {
			const mapeamento = {
				'DIARIA': 'Diária',
				'A_CADA_DOIS_DIAS': 'A cada 2 dias',
				'A_CADA_TRES_DIAS': 'A cada 3 dias'
			}
			return mapeamento[valor] || valor
		},

		/**
		 * Converte o valor do enum do backend para o valor do dropdown de período disponível
		 */
		converterEnumParaPeriodoDisponivel(valor) {
			const mapeamento = {
				'MENSAL': 'Mensal',
				'BIMESTRAL': 'Bimestral',
				'TRIMESTRAL': 'Trimestral'
			}
			return mapeamento[valor] || valor
		},

		/**
		 * Limpa os campos da etapa de Operação
		 */
		limparCamposOperacao() {
			this.model.orsv_tx_versao_dendrometro = ''
			this.model.orsv_dt_hora_inicio_medicao = ''
			this.model.orsv_tx_frequencia_coleta = ''
			this.model.orsv_tx_periodo_disponivel = ''
			this.horaInicio = ''
			this.fusoHorario = ''
			this.dadosOperacaoOriginais = {
				orsv_dt_hora_inicio_medicao: '',
				orsv_tx_frequencia_coleta: '',
				orsv_tx_periodo_disponivel: '',
				horaInicio: '',
				fusoHorario: ''
			}
			// Incrementa o dropdownKey para forçar a recriação dos dropdowns
			this.dropdownKey++
		},

		/**
		 * Salva os dados de operação da ordem de serviço
		 */
		salvarDadosOperacao() {
			// Valida se todos os campos obrigatórios estão preenchidos
			if (!this.model.orsv_dt_hora_inicio_medicao ||
				!this.model.orsv_tx_frequencia_coleta ||
				!this.model.orsv_tx_periodo_disponivel ||
				!this.horaInicio ||
				!this.fusoHorario) {
				this.mutationShowMessage({
					messageIcon: 'fas fa-exclamation-circle',
					messageType: 'warning',
					messageText: 'Por favor, preencha todos os campos obrigatórios.',
				})
				return
			}

			const dadosOperacao = {
				id: this.model.id,
				orsv_dt_hora_inicio_medicao: this.model.orsv_dt_hora_inicio_medicao,
				orsv_tx_frequencia_coleta: this.converterFrequenciaColetaParaEnum(this.model.orsv_tx_frequencia_coleta),
				orsv_tx_periodo_disponivel: this.converterPeriodoDisponivelParaEnum(this.model.orsv_tx_periodo_disponivel),
				orsv_tx_fuso_horario: this.fusoHorario,
				orsv_tx_versao_dendrometro: this.model.orsv_tx_versao_dendrometro,
				executoresIds: this.model.executoresIds || []
			}

			updateOrdemDeServico(dadosOperacao)
				.then((response) => {
					this.atualizaVersaoDendrometroNaLista(dadosOperacao.id, dadosOperacao.orsv_tx_versao_dendrometro)
					this.mostrarOperacao = false
					this.mostrarMapaPlantio = false
					this.mutationShowMessage({
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
						messageText: 'Configurações de operação salvas com sucesso!',
					})
					// Limpa os campos de operação
					this.limparCamposOperacao()
					// Fecha explicitamente o formulário e retorna para a listagem
					this.showForm = false
					this.resetState()
					// Atualiza a tabela para refletir as mudanças na coluna amostras
					this.refreshTabela()
				})
				.catch((error) => {
					this.mutationShowMessage({
						messageIcon: 'fas fa-exclamation-circle',
						messageType: 'error',
						messageText: 'Erro ao salvar configurações de operação. Tente novamente.',
					})
					console.error('Erro ao salvar dados de operação:', error)
				})
		},

		/**
		 * Atualiza otimisticamente a versão do dendrômetro de uma OS na lista local
		 * para refletir a mudança imediatamente, sem depender do refreshTabela().
		 */
		atualizaVersaoDendrometroNaLista(osId, versao) {
			const idx = this.modelList.findIndex((os) => os.id === osId)
			if (idx !== -1) {
				this.modelList.splice(idx, 1, {
					...this.modelList[idx],
					orsv_tx_versao_dendrometro: versao,
				})
			}
		},
	},
}
</script>

<style scoped src="../../../css/crud.css"></style>
<style scoped>
.BackArrow {
	width: 2.5rem;
	height: 3rem;
	position: fixed;
	top: 5rem;
	right: 0%;
	z-index: 10;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.go__to__plan__text {
	margin: 0;
	text-align: end;
	font-size: 0.8rem;
	cursor: pointer;
	display: flex;
	gap: 0.5rem;
}

.go__to__plan__text:hover {
	color: var(--color-green);
}

.info__title__service__name {
	height: fit-content;
	font-size: 1.1rem;
	margin: 0;
	text-overflow: ellipsis;
	width: 28rem;
	white-space: nowrap;
	overflow: hidden;
	padding: 0.5rem 0;
}

.container__loading {
	width: auto;
}

@media screen and (min-width: 768px) {
	.info__title__service__name {
		height: fit-content;
		padding: 0;
		width: 17rem;
		font-size: 0.9rem;
		margin: 0;
	}
}
</style>
